import facebook from "../../../Utils/assets/img/Icons1/facebook.png";
import email from "../../../Utils/assets/img/Icons1/email.png";
import razorpay2 from "../../../Utils/assets/img/Icons1/razorpay2.png";
import indiamart from "../../../Utils/assets/img/Icons1/indiamart.png";
import msg91 from "../../../Utils/assets/img/Icons1/msg91.png";
import tradeindia from "../../../Utils/assets/img/Icons1/trade-india.png";
import justdial from "../../../Utils/assets/img/Icons1/just-dial.png";
import GoogleAds from "../../../Utils/assets/img/Icons1/GoogleAds.png";
import sulekha_removebg_preview from "../../../Utils/assets/img/Icons1/sulekha_removebg_preview.png";
import Housingcom from "../../../Utils/assets/img/Icons1/Housingcom.png";
import quikr2 from "../../../Utils/assets/img/Icons1/quikr2.png";
import Apollo from "../../../Utils/assets/img/Icons1/Apollo.png";
import MagicBricks from "../../../Utils/assets/img/Icons1/MagicBricks.png";
import logo99acres from "../../../Utils/assets/img/Icons1/logo99acres.png";
import IndiaProperty from "../../../Utils/assets/img/Icons1/IndiaProperty.png";
import PropertyWala from "../../../Utils/assets/img/Icons1/PropertyWala.png";
import RoofandFloor from "../../../Utils/assets/img/Icons1/RoofandFloor.png";
import LiveSquare from "../../../Utils/assets/img/Icons1/LiveSquare.png";
import CommonFloor from "../../../Utils/assets/img/Icons1/CommonFloor.png";
import makaan from "../../../Utils/assets/img/Icons1/makaan.png";
import Interakt from "../../../Utils/assets/img/Icons1/Interakt.png";
import wati from "../../../Utils/assets/img/Icons1/wati.png";
import NetCore from "../../../Utils/assets/img/Icons1/NetCore.png";
import pinnacle from "../../../Utils/assets/img/Icons1/pinnacle.png";
import Moplet from "../../../Utils/assets/img/Icons1/Moplet.png";
import whatzapi from "../../../Utils/assets/img/Icons1/whatzapi.png";
import Tubelight_Logo from "../../../Utils/assets/img/Icons1/Tubelight_Logo.png";
import GreenAdsGlobal from "../../../Utils/assets/img/Icons1/GreenAdsGlobal.png";
import gupshup from "../../../Utils/assets/img/Icons1/gupshup.png";
import Twilio from "../../../Utils/assets/img/Icons1/Twilio.png";
import gallabox from "../../../Utils/assets/img/Icons1/gallabox.png";
import MyOperator from "../../../Utils/assets/img/Icons1/MyOperator.png";
import krispcall from "../../../Utils/assets/img/Icons1/krispcall.png";
import callHippo from "../../../Utils/assets/img/Icons1/callHippo.png";
import TataTele from "../../../Utils/assets/img/Icons1/TataTele.png";
import voxbay from "../../../Utils/assets/img/Icons1/voxbay.png";
import BigVTelecom from "../../../Utils/assets/img/Icons1/BigVTelecom.png";
import callerDesk from "../../../Utils/assets/img/Icons1/callerDesk.png";
import DIALDESK from "../../../Utils/assets/img/Icons1/DIALDESK.png";
import servetel from "../../../Utils/assets/img/Icons1/servetel.png";
import Knowlarity from "../../../Utils/assets/img/Icons1/Knowlarity.png";
import Ozonetel from "../../../Utils/assets/img/Icons1/Ozonetel.png";
import Exotel from "../../../Utils/assets/img/Icons1/Exotel.png";
import Mcube from "../../../Utils/assets/img/Icons1/Mcube.png";
import aircall from "../../../Utils/assets/img/Icons1/aircall.png";
import kaleyra from "../../../Utils/assets/img/Icons1/kaleyra.png";
import Bonvoice from "../../../Utils/assets/img/Icons1/Bonvoice.png";
import CloudShopee from "../../../Utils/assets/img/Icons1/CloudShopee.png";
import Teams from "../../../Utils/assets/img/Icons1/Teams.png";
import mailchimp from "../../../Utils/assets/img/Icons1/mailchimp.png";
import outlook from "../../../Utils/assets/img/Icons1/outlook.png";
import Mailjet from "../../../Utils/assets/img/Icons1/Mailjet.png";
import zohobooks from "../../../Utils/assets/img/Icons1/zohobooks.png";
import PayU from "../../../Utils/assets/img/Icons1/PayU.png";
import stripe2 from "../../../Utils/assets/img/Icons1/stripe2.png";
import QuickBooks from "../../../Utils/assets/img/Icons1/QuickBooks.png";
import Zendesk from "../../../Utils/assets/img/Icons1/Zendesk.png";
import Zapier from "../../../Utils/assets/img/Icons1/Zapier.png";
import integrately from "../../../Utils/assets/img/Icons1/integrately.png";
import Arka from "../../../Utils/assets/img/Icons1/Arka.png";
import iris from "../../../Utils/assets/img/Icons1/iris.png";
import channelpartner from "../../../Utils/assets/img/Icons1/channelpartner.png";
import Authkey from "../../../Utils/assets/img/Icons1/Authkey.png";
import Go2market from "../../../Utils/assets/img/Icons1/Go2market.png";
import sakari from "../../../Utils/assets/img/Icons1/sakari.png";
import msgadvert from "../../../Utils/assets/img/Icons1/msgadvert.png";
import OneXtel from "../../../Utils/assets/img/Icons1/OneXtel.png";
import keepintouch from "../../../Utils/assets/img/Icons1/keepintouch.png";
import smsInsta from "../../../Utils/assets/img/Icons1/smsInsta.png";
import Shopify from "../../../Utils/assets/img/Icons1/Shopify.png";
import setu from "../../../Utils/assets/img/Icons1/setu.png";
import digio from "../../../Utils/assets/img/Icons1/digio.png";

export const integrations = [
  {
    id: "indiamart",
    name: "Indiamart",
    category: "Online B2B Marketplace",
    path: "/settings/integration/indiamart",
    description:
      "Seamlessly capture leads from your IndiaMART account, either periodically or in real time.",
    logo: indiamart,
    details: {
      overview: `
    <div style="margin-bottom:12px; font-size:"12px">
    This application enables you to automatically capture and sync leads generated from your Indiamart account directly into PUG CRM.
    </div>
    
   <div>
   The Indiamart Lead Integration ensures that all incoming enquiries are seamlessly recorded within your CRM, eliminating manual data entry and reducing the chances of missed opportunities.
   </div>

   <div className=""> With intelligent source mapping, users can categorize and filter leads effectively, allowing better tracking, segmentation, and conversion management within PUG CRM.</div>`,

      howItWorks: {
        description:
          "Follow these steps to install and configure the Indiamart Lead Integration app in PUG CRM.",

        steps: [
          "Click on the Install App button",
          "Click on 'Allow and Install'",
          "After installation, sign up on the app",
          "Verify your email and login",
          "Navigate to 'Installed Apps' under Marketplace",
          "Click on 'View Details' of the Indiamart Lead Integration app",
        ],

        setup: [
          "Go to API Keys section of the Indiamart application and enter your PUG CRM API key",
          "Click on the Save button",
          "Go to Indiamart Settings section and enter the required details",
          "Enter your mobile number (same as seller portal login)",
          "Enter your Indiamart API key",
          "Choose vendor as Indiamart",
          "Map campaign and lead source",
          "Click on Save",
        ],

        note: [
          "Once your account is connected, leads will start syncing within 15 minutes",
          "You can view leads inside PUG CRM under Lead Listing and Lead Logs",
        ],
      },

      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },

  {
    id: "tradeindia",
    name: "TradeIndia",
    category: "Sourcing Marketplace",
    path: "/settings/integration/tradeindia",
    description:
      "Seamlessly sync your TradeIndia business inquiries directly into PUG CRM for faster response and better lead management.",
    logo: tradeindia,

    details: {
      overview: `
      <div style="margin-bottom:16px; line-height:1.5;">
        This application enables you to <strong>automatically capture and sync leads</strong> generated from your TradeIndia seller account directly into PUG CRM.
      </div>
      <div style="margin-bottom:16px; line-height:1.5;">
        The TradeIndia Lead Integration ensures that every incoming enquiry—whether for a specific product or a general business query—is recorded instantly, eliminating manual data entry.
      </div>
      <div style="margin-bottom:16px; line-height:1.5;">
        With <strong>intelligent source mapping</strong>, you can automatically assign leads to specific campaigns and track their conversion journey within PUG CRM.
      </div>
    `,
      howItWorks: {
        description:
          "The steps below guide you through the complete integration of TradeIndia with your application, helping you capture buyer inquiries, manage leads, and streamline your sales workflow from a single platform.",


        steps: [
          "Click on the 'Install App' button to begin.",
          "A configuration modal will appear for API authentication.",
          "Enter your TradeIndia credentials (User ID, Profile ID, and API Key).",
          "Configure your lead mapping (Campaign and Source).",
          "Click 'Verify and Save' to activate the real-time sync.",
        ],

        setup: [
          "Login to your TradeIndia Seller account.",
          "Switch to 'Old MTI' interface if you are on the new dashboard.",
          "Navigate to 'Inquiries & Contacts' > 'My Inquiry API'.",
          "Copy your User ID (e.g., 28811063) and Profile ID (e.g., 159089863).",
          "Copy your unique API Key from the same section.",
          "Paste these details into the PUG CRM integration modal.",
          "Select your preferred Campaign and Source for incoming leads.",
          "Click 'Save' to start the 15-minute sync cycle.",
        ],
        // banner2: {
        //   type: "image",
        //   url: logo99acres,
        // },

        note: [
          "Ensure your TradeIndia API is active (Check 'My Inquiry API' section).",
          "Sync usually takes 15 minutes to reflect new inquiries in PUG CRM.",
          "You can monitor all activity in the Lead Logs section.",
        ],
        // banner3: {
        //   type: "image",
        //   url: logo99acres,
        // },
      },

      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },

  {
    id: "justdial",
    name: "JustDial",
    category: "Local search engine for services",
    path: "/settings/integration/justdial",
    description:
      "Directly capture all leads incoming from justdial.com into your CRM.",
    logo: justdial,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  This application enables you to seamlessly capture and sync leads generated from your JustDial account directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  JustDial is a leading Indian local search platform that provides information about various services through its website, mobile application, and phone-based services. With the JustDial Lead Integration, you can automatically fetch all incoming enquiries into PUG CRM without any manual intervention.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures real-time lead synchronization, allowing your team to respond faster, manage prospects efficiently, and eliminate delays caused by offline lead sharing.
</p>

<p style="margin-bottom:12px !important;">
  <strong>Prerequisites:</strong> You must have an active paid plan on JustDial and a valid PUG CRM account to use this integration.
</p>
`,
      howItWorks: {
        description:
          "The steps below walk you through the complete integration of Justdial with your application, allowing you to capture leads, manage customer interactions, and streamline your workflow through a unified system.",
        steps: [
          "Click on the Install App button",
          "After installation, sign up on the application",
          "Verify your email account and log in to the JustDial Lead Integration app",
          "Enter your PUG CRM API key and click on Save",
          "Navigate to the 'JustDial Settings' section",
          "Click on 'Add Connected Accounts'",
          "Enter Account Name and select Campaign, Source, Product/Service, and Owner for lead mapping",
          "Set the status as Active",
          "Click on Save",
          "Copy the Webhook URL from the Connected Accounts listing page",
          "Share the Webhook URL with the JustDial backend team for configuration",
          "Once configured, JustDial will start sending leads to PUG CRM automatically",
        ],

        setup: [
          "Ensure the Webhook URL is correctly configured by the JustDial team",
          "Verify that your API key and mapping fields are properly set",
          "Check the Connected Accounts section to confirm active configuration",
        ],

        note: [
          "Once the setup is complete, leads will start appearing in PUG CRM",
          "You can view all incoming leads in the Lead Listing section",
          "To check failed integrations, navigate to the 'Failed Leads' section in the JustDial Integration app",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },

  {
    id: "facebook",
    name: "Facebook Lead Integration",
    category: "Lead generation platform",
    path: "/settings/integration/facebook",
    description: "Generate and capture leads seamlessly with Facebook Ads.",
    logo: facebook,

    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  This application allows you to automatically capture and sync leads generated through your Facebook campaigns directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  The Facebook Lead Integration ensures that all leads collected via Facebook Lead Ads are seamlessly transferred to PUG CRM in real-time, eliminating manual data entry and reducing response time.
</p>

<p style="margin-bottom:12px !important;">
  With this integration, users can connect their active Facebook lead forms, manage incoming enquiries efficiently, and streamline lead handling within a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Connect Facebook lead forms from active campaigns</li>
  <li>Map appropriate Campaign and Source for better lead tracking</li>
  <li>Associate relevant products or services with incoming leads</li>
  <li>Automatically assign leads to specific users or teams</li>
</ul>
`,
      howItWorks: {
        description:
          "Follow the step-by-step process below to seamlessly integrate Facebook Lead Ads with your application, enabling automatic capture and management of customer leads.",
        steps: [
          "Click on the Install App button",
          "Click on 'Allow and Install'",
          "After installation, sign up on the application",
          "Verify your email and log in",
          "Navigate to 'Installed Apps' under Marketplace",
          "Click on 'View Details' of the Facebook Lead Integration app",
          "Go to Facebook Settings and connect your Facebook account (with pages and campaigns)",
        ],

        setup: [
          "After connecting your Facebook account, navigate to the Forms section",
          "View all pages and campaigns associated with your account",
          "Click on Add to select campaigns from which you want to capture leads into PUG CRM",
          "Click on Edit to configure field mapping",
          "You will see two sections: Lead Field Mapping and Contact Field Mapping",
          "Select Campaign, Source, and Owner for proper lead assignment",
          "Enable the checkbox 'Create Lead/Contact'",
          "Map Facebook form fields with corresponding PUG CRM fields",
          "Click on Add Field Mapping and repeat for all required fields",
        ],

        testing: [
          "Go to https://developers.facebook.com/tools/lead-ads-testing",
          "Log in with your Facebook account",
          "Select the Facebook page and form you want to test",
          "Click on 'Create Lead'",
          "Click on 'Track Status' to check for errors",
          "If successful, verify that the test lead appears in your PUG CRM account",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "You can manage all incoming leads from the Lead Listing section",
          "For further assistance, refer to the Help section within the application",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "razorpay",
    name: "Razorpay",
    path: "/settings/integration/razorpay",
    category: "Unified online payment portal",
    description: "Smarter finances to fuel business growth.",
    logo: razorpay2,
    details: {
      overview: `
    <p style="margin-bottom:12px !important;">
  Razorpay is a leading online payment gateway that enables businesses to collect payments seamlessly. With the Razorpay Integration in PUG CRM, you can generate and manage payment links directly from your CRM without switching between     platforms.
     </p>

<p style="margin-bottom:12px !important;">
  This integration allows users to quickly create payment links for deals, leads, or contacts and share them instantly via email or SMS, ensuring a faster and more streamlined payment collection process.
</p>

<p style="margin-bottom:12px !important;">
  Once a payment is successfully completed, the system can automatically trigger actions within PUG CRM, helping you keep your sales pipeline updated and improving overall workflow efficiency.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Generate payment links directly from PUG CRM</li>
  <li>Share payment links via Email or SMS</li>
  <li>Track payment status in real-time</li>
  <li>Automate actions after successful payment</li>
</ul>
`,
      howItWorks: {
        description: "Follow the step-by-step process below to seamlessly integrate Razorpay with your application, enabling secure and efficient online payment processing.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Log in to your PUG CRM account",
          "Click on 'Allow and Install'",
          "After installation, sign up using your email ID",
          "Verify your email and log in to the application",
        ],

        setup: [
          "Navigate to 'Installed Apps' under Marketplace",
          "Click on 'View Details' for Razorpay Integration",
          "Go to the API Keys section and enter your PUG CRM API key",
          "Click on Save",
          "Go to 'Connected Accounts' and click on 'Add Connected Account'",
          "Select vendor as Razorpay",
          "Enter your Razorpay Key ID and Key Secret",
          "Enable the account and save the configuration",
        ],

        automation: [
          "Go to 'After Payment Actions' under Connected Accounts",
          "Click on 'Add Payment Action'",
          "Select event and define action (e.g., update deal stage)",
          "Configure multiple actions based on your workflow",
        ],

        webhook: [
          "Go to 'Connected Accounts' and copy the Webhook URL",
          "Log in to your Razorpay account and navigate to Webhook settings",
          "Paste the Webhook URL and select event: payment_link_paid",
          "Save the webhook configuration",
          "Razorpay will now send payment events to PUG CRM",
        ],

        users: [
          "Navigate to 'Manage Users' in the Razorpay app",
          "Click on 'Add User'",
          "Enter user details and assign role (Admin or Member)",
          "Map the user with a PUG CRM user",
          "Users will receive an email to verify and access the application",
          "Admins can access all features, Members have limited access",
        ],

        usage: [
          "Go to Lead or Deal details page in PUG CRM",
          "Click on 'More Actions' and select 'Generate Payment Link'",
          "Enter required details and create the payment link",
          "Share the link with customers via email or SMS",
          "Track payment status and manage links (view, resend, cancel)",
          "After successful payment, actions are triggered automatically",
        ],

        note: [
          "Payment details are logged automatically within the CRM",
          "Automation ensures your sales pipeline stays updated in real-time",
          "You can track all generated payment links from the application dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "msg91",
    name: "MSG91",
    path: "/integration/msg91",
    category: "SMS, Whatsapp, Email and IVR",
    description:
      "Power your platform with secure, robust APIs for SMS, Email, Voice, Authentication, and beyond.",
    logo: msg91,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  MSG91 integration allows you to seamlessly add multi-channel communication capabilities such as SMS, Email, RCS, and WhatsApp directly into your PUG CRM workflows.
</p>

<p style="margin-bottom:12px !important;">
  With this integration, you can automate notifications, engage with leads, and streamline communication across multiple channels without leaving the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Simply install the MSG91 application, connect your account, and start sending messages through your configured workflows instantly.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send SMS, Email, RCS, and WhatsApp messages from PUG CRM</li>
  <li>Automate communication within workflows</li>
  <li>Engage leads across multiple channels from a single platform</li>
  <li>Improve response time and customer experience</li>
</ul>

<p style="margin-bottom:12px !important;">
  <strong>Support:</strong> For assistance, please contact the MSG91 team via their official support channels.
</p>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of MSG91 with your application, allowing you to send SMS notifications, deliver OTPs, and automate customer communication efficiently.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Log in to your PUG CRM account",
          "Click on 'Allow and Install'",
          "After installation, sign up using your email ID",
          "Verify your email and log in to the application",
        ],

        setup: [
          "Navigate to 'Installed Apps' under Marketplace",
          "Click on 'View Details' for Razorpay Integration",
          "Go to the API Keys section and enter your PUG CRM API key",
          "Click on Save",
          "Go to 'Connected Accounts' and click on 'Add Connected Account'",
          "Select vendor as Razorpay",
          "Enter your Razorpay Key ID and Key Secret",
          "Enable the account and save the configuration",
        ],

        automation: [
          "Go to 'After Payment Actions' under Connected Accounts",
          "Click on 'Add Payment Action'",
          "Select event and define action (e.g., update deal stage)",
          "Configure multiple actions based on your workflow",
        ],

        webhook: [
          "Go to 'Connected Accounts' and copy the Webhook URL",
          "Log in to your Razorpay account and navigate to Webhook settings",
          "Paste the Webhook URL and select event: payment_link_paid",
          "Save the webhook configuration",
          "Razorpay will now send payment events to PUG CRM",
        ],

        users: [
          "Navigate to 'Manage Users' in the Razorpay app",
          "Click on 'Add User'",
          "Enter user details and assign role (Admin or Member)",
          "Map the user with a PUG CRM user",
          "Users will receive an email to verify and access the application",
          "Admins can access all features, Members have limited access",
        ],

        usage: [
          "Go to Lead or Deal details page in PUG CRM",
          "Click on 'More Actions' and select 'Generate Payment Link'",
          "Enter required details and create the payment link",
          "Share the link with customers via email or SMS",
          "Track payment status and manage links (view, resend, cancel)",
          "After successful payment, actions are triggered automatically",
        ],

        note: [
          "Payment details are logged automatically within the CRM",
          "Automation ensures your sales pipeline stays updated in real-time",
          "You can track all generated payment links from the application dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "email",
    name: "Gmail",
    path: "/integration/email",
    category: "Email Integration",
    description:
      "Keep leads and prospects engaged with steady, automated email communication.",
    logo: email,
    details: {
      overview: `
<p style="margin-bottom:12px;">
  The Gmail Integration allows you to connect your email account with PUG CRM to manage conversations, track emails, and streamline communication with leads and customers.
</p>

<p style="margin-bottom:12px;">
  Gmail is one of the most widely used email platforms, enabling seamless communication for businesses. By integrating Gmail with PUG CRM, you can sync emails, send messages directly from the CRM, and keep all interactions organized in one place.
</p>

<p style="margin-bottom:12px;">
  This integration helps improve communication efficiency, ensures better tracking of email interactions, and enhances customer engagement.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send and receive emails directly from PUG CRM</li>
  <li>Sync email conversations with leads and contacts</li>
  <li>Track email opens and responses</li>
  <li>Improve communication and follow-ups</li>
</ul>
`,
      howItWorks: {
        description:"Follow the step-by-step process below to seamlessly integrate Gmail with your application, enabling efficient email communication and management.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Gmail (Google) account",
          "Navigate to Marketplace → Installed Apps → Gmail Integration",
          "Authorize access to your Gmail account",
        ],

        setup: [
          "Complete OAuth authentication with your Google account",
          "Allow required email permissions (read, send, manage)",
          "Configure email sync settings (inbox, sent, labels)",
          "Set up default sender email and signature",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name and Email Address",
          "Map email fields like Subject, Body, and Attachments",
          "Map activity fields such as Sent, Received, and Open Status",
          "Map additional fields like Labels, Threads, and Timestamp",
        ],
      },
    },
  },
  {
    id: "googleads",
    name: "Google Ads",
    path: "/settings/integration/googleads",
    category: "Lead generation platform",
    description:
      "Automatically capture Google-generated leads directly into your CRM.",
    logo: GoogleAds,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Google Ads Integration enables you to automatically capture and sync leads generated from your Google Ads campaigns directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Google Ads is a powerful marketing platform used by businesses to attract and convert potential customers. With this integration, all leads generated through your campaigns are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual data entry, ensures faster lead response, and helps your team manage and nurture prospects more efficiently within a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from Google Ads campaigns</li>
  <li>Sync leads directly into PUG CRM in real-time</li>
  <li>Create leads or contacts with proper source mapping</li>
  <li>Improve lead tracking and conversion efficiency</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Google Ads with your application, allowing you to track campaign performance, capture leads, and optimize your advertising workflow.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Google Ads Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to the Webhooks section and click on 'New Webhook'",
          "Enter a name, enable the webhook, and save",
          "A Webhook URL will be generated",
        ],

        mapping: [
          "Go to the 'Map Fields' section",
          "Select whether to create Lead, Contact, or both",
          "Map Google Ads form fields with corresponding PUG CRM fields",
          "Configure additional fields like Source, Campaign, Product/Service, Owner, and UTM parameters",
          "Ensure correct field type mapping to avoid data mismatch",
        ],

        webhook: [
          "Copy the generated Webhook URL",
          "Go to your Google Ads Lead Form settings",
          "Paste the Webhook URL into the webhook integration section",
          "Save the configuration",
          "Submit test data to verify lead creation in PUG CRM",
        ],

        logs: [
          "Navigate to the 'Sync Logs' section in the application",
          "View all incoming leads and their status",
          "Check error messages for failed records",
          "Click on 'Details' to inspect lead data",
        ],

        note: [
          "Once configured, leads will automatically sync from Google Ads to PUG CRM",
          "Ensure webhook and field mapping are correctly set for smooth data flow",
          "Use Sync Logs to monitor integration health and troubleshoot issues",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "sulekha",
    name: "Sulekha",
    path: "/settings/integration/sulekha",
    category: "Real Estate Lead Capture",
    description:
      "Automatically capture all enquiries and never miss out on incoming leads.",
    logo: sulekha_removebg_preview,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Sulekha Integration enables you to automatically capture and sync leads generated from your Sulekha account directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Sulekha is a popular platform for discovering local services and generating customer enquiries. With this integration, all incoming leads from Sulekha are seamlessly transferred into PUG CRM in real-time, ensuring no opportunity is missed.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead handling, improves response time, and allows your team to efficiently manage and nurture prospects from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from Sulekha</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and owners</li>
  <li>Improve lead tracking and conversion efficiency</li>
</ul>
`,
      howItWorks: {
        description:"Follow the step-by-step process below to seamlessly integrate Sulekha with your application, enabling efficient lead capture and management.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Sulekha Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter required Sulekha account details provided by Sulekha team",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the Sulekha support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, Sulekha will start sending leads to PUG CRM",
        ],

        mapping: [
          "Ensure proper mapping of lead fields such as Name, Phone, Email, and Service",
          "Map additional fields like Campaign, Source, and Product/Service",
          "Verify field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to troubleshoot and monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically",
          "Ensure webhook configuration is completed by Sulekha team",
          "You can manage all leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "housing",
    name: "Housing.com",
    path: "/settings/integration/housing",
    category: "Real Estate Lead Capture",
    description:
      "Seamlessly capture leads and map property inquiries from Housing.com.",
    logo: Housingcom,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Housing.com Integration allows you to automatically capture and sync property enquiries generated from your Housing.com listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Housing.com is a leading real estate platform where buyers and tenants discover properties. With this integration, all incoming leads from your property listings are seamlessly pushed into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead tracking, ensures faster follow-ups, and helps your sales team efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture property enquiries from Housing.com</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"This section outlines the step-by-step process to integrate Housing.com with your application, ensuring smooth lead synchronization, data accuracy, and reliable system performance.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Housing.com Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter Housing.com account credentials or details provided by the Housing.com team",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the Housing.com support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, Housing.com will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, and Source",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming Housing.com leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the Housing.com team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "quikr",
    name: "Quikr",
    path: "/settings/integration/quikr",
    category: "Real Estate Lead Capture",
    description:
      "Seamlessly capture Quikr leads in real time or at scheduled intervals.",
    logo: quikr2,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Quikr Integration enables you to automatically capture and sync leads generated from your Quikr listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Quikr is a widely used classifieds platform where businesses and individuals connect with potential customers across multiple categories. With this integration, all incoming enquiries from your Quikr listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead handling, ensures faster response times, and helps your team efficiently manage and convert prospects from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from Quikr listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and categories</li>
  <li>Assign leads to relevant users for quick follow-up</li>
</ul>
`,
      howItWorks: {
        description:"Follow the step-by-step process below to seamlessly integrate Quikr with your application, enabling efficient lead capture and inquiry management.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Housing.com Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter Housing.com account credentials or details provided by the Housing.com team",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the Housing.com support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, Housing.com will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, and Source",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming Housing.com leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the Housing.com team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "apollo",
    name: "Apollo.io",
    path: "/settings/integration/apollo",
    category: "Lead Enrichment",
    description:
      "Identify, engage, and close your ideal buyers using Apollo.io.",
    logo: Apollo,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Apollo.io Integration enables you to seamlessly capture and sync prospects and leads from Apollo.io directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Apollo.io is a powerful B2B sales intelligence and prospecting platform that helps businesses discover and engage with potential customers. With this integration, you can automatically import contacts and leads into PUG CRM for streamlined sales management.
</p>

<p style="margin-bottom:12px !important;">
  This integration eliminates manual data entry, ensures faster lead engagement, and allows your sales team to manage prospects efficiently from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Import prospects and contacts from Apollo.io into PUG CRM</li>
  <li>Automatically create leads or contacts</li>
  <li>Map campaigns, sources, and ownership</li>
  <li>Improve prospect tracking and conversion efficiency</li>
</ul>
`,
      howItWorks: {
        description:"Follow the step-by-step process below to seamlessly integrate Apollo.io with your application, enabling efficient lead generation and contact management.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Apollo.io Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Apollo.io API key or connect your Apollo account",
          "Navigate to 'Connected Accounts' and verify connection",
          "Select Campaign, Source, and Owner for lead mapping",
        ],

        mapping: [
          "Map Apollo.io fields such as Name, Email, Phone, Company, and Job Title",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure proper field type matching to avoid data mismatch",
        ],

        sync: [
          "Choose how you want to import data (manual import or automated sync)",
          "Select lists, sequences, or saved searches from Apollo.io",
          "Configure sync frequency if automation is enabled",
          "Leads and contacts will be created automatically in PUG CRM",
        ],

        logs: [
          "Navigate to the 'Sync Logs' section",
          "View imported records and their status",
          "Check error logs for failed records",
          "Use logs to monitor sync performance",
        ],

        note: [
          "Ensure your Apollo.io API key has required permissions",
          "Data sync depends on selected lists or filters in Apollo.io",
          "You can manage all imported leads and contacts in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "magicBricks",
    name: "MagicBricks",
    path: "/settings/integration/magicBricks",
    category: "Real Estate Lead Capture",
    description:
      "Seamlessly capture leads and organize property inquiries from Magicbricks.com.",
    logo: MagicBricks,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MagicBricks Integration enables you to automatically capture and sync property enquiries generated from your MagicBricks listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  MagicBricks is one of India's leading real estate platforms where buyers and tenants search for properties. With this integration, all incoming leads from your property listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This helps eliminate manual lead tracking, ensures faster follow-ups, and allows your sales team to efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from MagicBricks listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of MagicBricks with your application, allowing you to capture, track, and manage property inquiries from a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → MagicBricks Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter MagicBricks account details or credentials provided by MagicBricks",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the MagicBricks support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, MagicBricks will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming MagicBricks leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the MagicBricks team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "99acres",
    name: "99 Acres",
    path: "/settings/integration/99acres",
    category: "Real Estate Lead Capture",
    description: "Seamlessly capture property enquiries from 99acres.com.",
    logo: logo99acres,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The 99acres Integration enables you to automatically capture and sync property enquiries generated from your 99acres listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  99acres is a leading real estate platform where buyers, sellers, and tenants connect to explore property listings. With this integration, all incoming leads from your listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead tracking, ensures faster follow-ups, and allows your team to efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from 99acres listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of 99acres with your application, allowing you to capture, track, and manage property inquiries from a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → 99acres Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter 99acres account details or credentials provided by the 99acres team",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the 99acres support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, 99acres will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming 99acres leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the 99acres team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "indiaProperty",
    name: "India Property",
    path: "/settings/integration/indiaProperty",
    category: "Real Estate Lead Capture",
    description:
      "Effortlessly generate and capture high-quality real estate leads.",
    logo: IndiaProperty,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The IndiaProperty Integration enables you to automatically capture and sync property enquiries generated from your IndiaProperty listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  IndiaProperty is a well-known real estate platform where users search for residential and commercial properties. With this integration, all incoming leads from your listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead tracking, ensures faster follow-ups, and helps your sales team efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from IndiaProperty listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"Integrating IndiaProperty into your application enables real-time property inquiry capture and lead management—follow the steps below to get started quickly.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → IndiaProperty Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter IndiaProperty account details or credentials provided by the IndiaProperty team",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the IndiaProperty support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, IndiaProperty will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming IndiaProperty leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the IndiaProperty team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "propertyWala",
    name: "Property Wala",
    path: "/settings/integration/propertyWala",
    category: "Real Estate Lead Capture",
    description:
      "Automatically capture all incoming real estate leads from Property Wala.",
    logo: PropertyWala,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Property Portal Integration enables you to automatically capture and sync property enquiries from multiple real estate platforms directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration supports various property listing platforms such as Housing, MagicBricks, 99acres, and others, allowing you to centralize all incoming leads in one place.
</p>

<p style="margin-bottom:12px !important;">
  With real-time lead synchronization, your team can respond faster, manage enquiries efficiently, and improve conversion rates without relying on manual lead tracking.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from multiple property portals</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster follow-ups</li>
</ul>
`,
      howItWorks: {
        description:"Getting started with PropertyWala integration is simple—follow the steps below to connect your application and start managing property leads effortlessly.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Property Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Select the property portal (e.g., Housing, MagicBricks, 99acres)",
          "Enter required account details",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the respective property portal team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, leads will start flowing into PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will sync automatically into PUG CRM",
          "Ensure webhook configuration is completed for each portal",
          "You can manage all property leads from the Lead Listing section",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "roof&floor",
    name: "Roof and Floor",
    path: "/settings/integration/roof&floor",
    category: "Real Estate Lead Capture",
    description:
      "Scale real estate lead generation by expanding your audience reach.",
    logo: RoofandFloor,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The RoofandFloor Integration enables you to automatically capture and sync property enquiries generated from your RoofandFloor listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  RoofandFloor is a real estate platform that connects buyers with property listings across various locations. With this integration, all incoming enquiries from your listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This helps eliminate manual lead tracking, ensures faster follow-ups, and allows your sales team to efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from RoofandFloor listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of RoofandFloor with your application, allowing you to capture, track, and manage property inquiries from a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → RoofandFloor Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter RoofandFloor account details or credentials provided by the platform",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the RoofandFloor support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, leads will start flowing into PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the RoofandFloor team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "livesquare",
    name: "Livesquare",
    path: "/settings/integration/livesquare",
    category: "Real Estate Lead Capture",
    description: "Expand your reach and accelerate lead generation.",
    logo: LiveSquare,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The LiveSquare Integration enables you to automatically capture and sync property enquiries and leads from LiveSquare directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  LiveSquare is a real estate lead aggregation platform that connects property developers and agents with potential buyers. With this integration, all incoming leads are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead handling, improves response time, and allows your sales team to efficiently manage and convert prospects from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from LiveSquare</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and project details</li>
  <li>Assign leads to sales agents for faster follow-up</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Livesquare with your application, allowing you to capture, track, and manage property inquiries from a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → LiveSquare Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter LiveSquare account credentials or details provided by the LiveSquare team",
          "Select Campaign, Source, Project, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the LiveSquare support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, LiveSquare will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map lead fields such as Name, Phone, Email, Project, and Budget",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the LiveSquare team",
          "You can manage all leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "commonfloor",
    name: "Common Floor",
    path: "/settings/integration/commonfloor",
    category: "Real Estate Lead Capture",
    description:
      "Tap into a powerful online real estate ecosystem to maximize lead generation.",
    logo: CommonFloor,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The CommonFloor Integration enables you to automatically capture and sync property enquiries generated from your CommonFloor listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  CommonFloor is a well-known real estate platform that connects property buyers, sellers, and tenants. With this integration, all incoming enquiries from your listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead tracking, ensures faster follow-ups, and allows your sales team to efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from CommonFloor listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of CommonFloor with your application, allowing you to capture, track, and manage property inquiries from a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → CommonFloor Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter CommonFloor account details or credentials provided by the platform",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the CommonFloor support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, CommonFloor will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the CommonFloor team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "makaan",
    name: "Makaan",
    path: "/settings/integration/makaan",
    category: "Real Estate Lead Capture",
    description: "Instantly capture Makaan leads and sync them to your CRM.",
    logo: makaan,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Makaan Integration enables you to automatically capture and sync property enquiries generated from your Makaan listings directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Makaan is a popular real estate platform where buyers and tenants explore property listings. With this integration, all incoming enquiries from your listings are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual lead tracking, ensures faster follow-ups, and helps your sales team efficiently manage and convert property enquiries from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from Makaan listings</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and property details</li>
  <li>Assign leads to agents for faster response</li>
</ul>
`,
      howItWorks: {
        description:"Getting started with Makaan integration is simple—follow the steps below to connect your application and start managing property leads effortlessly.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Makaan Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys section",
          "Enter your PUG CRM API key and save",
          "Navigate to 'Connected Accounts' section",
          "Click on 'Add Connected Account'",
          "Enter Makaan account details or credentials provided by the platform",
          "Select Campaign, Source, and Owner for lead mapping",
          "Enable the account and save the configuration",
        ],

        webhook: [
          "Copy the Webhook URL generated in the application",
          "Share the Webhook URL with the Makaan support/backend team",
          "Request them to configure lead delivery to the provided Webhook URL",
          "Once configured, Makaan will start sending leads to PUG CRM automatically",
        ],

        mapping: [
          "Map property enquiry fields such as Name, Phone, Email, and Property details",
          "Map additional fields like Project, Location, Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        logs: [
          "Navigate to the 'Lead Logs' or 'Sync Logs' section",
          "View all incoming Makaan leads and their status",
          "Check error logs for failed lead entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Once setup is complete, leads will start syncing automatically into PUG CRM",
          "Ensure webhook configuration is completed by the Makaan team",
          "You can manage all property leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "interakt",
    name: "Interakt",
    path: "/settings/integration/interakt",
    category: "Business Whatsapp",
    description:
      "Drive business growth while elevating customer experience with WhatsApp.",
    logo: Interakt,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Interakt Integration enables you to connect your WhatsApp Business account with PUG CRM and manage customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Interakt is a WhatsApp Business API platform that allows businesses to send automated messages, notifications, and campaigns. With this integration, you can engage with leads and customers on WhatsApp without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This helps streamline communication, improve response time, and automate follow-ups, ensuring a better customer experience and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send WhatsApp messages directly from PUG CRM</li>
  <li>Automate notifications and follow-ups</li>
  <li>Engage leads in real-time via WhatsApp</li>
  <li>Track communication and improve conversions</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Interakt with your application, allowing you to automate conversations, manage customer interactions, and streamline communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Interakt Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Interakt API key or connect your Interakt account",
          "Verify your WhatsApp Business number is linked with Interakt",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Configure automated WhatsApp messages for new leads or events",
          "Set up templates for notifications and follow-ups",
          "Trigger messages based on actions like lead creation or status change",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send WhatsApp messages directly using Interakt integration",
          "Use pre-approved templates for communication",
          "Track message delivery and responses",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed message attempts",
          "Monitor communication performance",
        ],

        note: [
          "Ensure your WhatsApp Business account is approved and active",
          "Message templates must be approved by WhatsApp",
          "You can manage all conversations directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "wati",
    name: "Wati",
    path: "/settings/integration/wati",
    category: "Business Whatsapp",
    description:
      "Power sales, support, and marketing conversations using WhatsApp.",
    logo: wati,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The WATI Integration enables you to connect your WhatsApp Business API account with PUG CRM and manage customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  WATI is a WhatsApp Business API platform that helps businesses send automated messages, notifications, and campaigns at scale. With this integration, you can engage with leads and customers on WhatsApp without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline communication, improve response time, and automate follow-ups, ensuring a better customer experience and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send WhatsApp messages directly from PUG CRM</li>
  <li>Automate notifications and follow-ups</li>
  <li>Engage leads in real-time via WhatsApp</li>
  <li>Track communication and improve conversions</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of WATI with your application, allowing you to automate conversations, manage customer interactions, and streamline communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → WATI Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your WATI API key and Endpoint URL",
          "Verify your WhatsApp Business number is connected with WATI",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Set up automated WhatsApp messages for new leads or events",
          "Configure message templates for notifications and follow-ups",
          "Trigger messages based on actions like lead creation, assignment, or status change",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send WhatsApp messages directly using WATI integration",
          "Use approved templates for communication",
          "Track message delivery and responses",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed message attempts",
          "Monitor communication performance",
        ],

        note: [
          "Ensure your WhatsApp Business API account is active and approved",
          "Message templates must be approved by WhatsApp",
          "You can manage all customer conversations directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "netcore",
    name: "Netcore",
    path: "/settings/integration/netcore",
    category: "Business Whatsapp",
    description: "Deliver timely, informative messages via WhatsApp.",
    logo: NetCore,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Netcore Integration enables you to connect your Netcore communication platform with PUG CRM and manage multi-channel customer engagement directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Netcore is a customer engagement and marketing automation platform that allows businesses to send Email, SMS, WhatsApp, and push notifications. With this integration, you can automate communication and interact with leads across multiple channels from a single interface.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer engagement, streamline communication workflows, and increase conversion rates by enabling timely and personalized interactions.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send Email, SMS, and WhatsApp messages from PUG CRM</li>
  <li>Automate multi-channel communication workflows</li>
  <li>Engage leads with personalized messaging</li>
  <li>Track communication performance and delivery status</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Netcore with your application, allowing you to automate messaging, manage campaigns, and streamline customer interactions across channels.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Netcore Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Netcore API key, account credentials, or service configuration details",
          "Configure required channels such as Email, SMS, or WhatsApp",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Email, Phone Number, and other attributes",
          "Ensure proper mapping for communication channels (Email/Phone)",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Create automated workflows for communication triggers",
          "Send messages based on events like lead creation, assignment, or status updates",
          "Configure personalized templates for different channels",
          "Set up campaign-based messaging for engagement",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send messages via Email, SMS, or WhatsApp using Netcore",
          "Use templates for consistent communication",
          "Track delivery status and user engagement",
        ],

        logs: [
          "Navigate to the 'Communication Logs' or 'Activity Logs' section",
          "View sent messages and delivery status across channels",
          "Check errors or failed message attempts",
          "Monitor campaign performance and engagement metrics",
        ],

        note: [
          "Ensure your Netcore account is active and properly configured",
          "Templates must be approved for certain channels like WhatsApp",
          "Multi-channel communication depends on enabled services in Netcore",
          "You can manage all customer communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "pinnacle",
    name: "Pinnacle",
    path: "/settings/integration/pinnacle",
    category: "Business Whatsapp",
    description: "Deliver timely, informative WhatsApp messages at scale.",
    logo: pinnacle,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Pinnacle Integration enables you to capture and sync leads and customer interactions from Pinnacle directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Pinnacle is a platform that helps businesses manage customer enquiries, calls, and lead generation processes. With this integration, all incoming leads and interactions are automatically recorded in PUG CRM for seamless tracking and follow-up.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual data entry, improves response time, and allows your team to manage customer interactions efficiently from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from Pinnacle</li>
  <li>Sync customer interactions into PUG CRM</li>
  <li>Map campaigns, sources, and ownership</li>
  <li>Improve lead tracking and follow-up efficiency</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Pinnacle with your application, allowing you to streamline operations, manage data, and improve overall system efficiency.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Pinnacle Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter Pinnacle account credentials or API key provided by Pinnacle",
          "Navigate to 'Connected Accounts' section and verify connection",
          "Select Campaign, Source, and Owner for lead mapping",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, Email, and Interaction details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        sync: [
          "Configure how leads and interactions should be synced",
          "Enable automatic sync for real-time data transfer",
          "Verify that incoming leads are being created in PUG CRM",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View all incoming leads and interaction records",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Ensure your Pinnacle account is active and properly configured",
          "Data sync depends on correct API and account configuration",
          "You can manage all leads and interactions from PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "moplet",
    name: "Moplet",
    path: "/settings/integration/moplet",
    category: "Business Whatsapp",
    description: "Deliver timely, informative WhatsApp messages effortlessly.",
    logo: Moplet,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MoPlate Integration enables you to automatically capture and sync leads generated from MoPlate directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  MoPlate is a platform that helps businesses generate and manage customer enquiries through various campaigns and channels. With this integration, all incoming leads are seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual data entry, improves response time, and allows your team to efficiently manage and convert leads from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads from MoPlate campaigns</li>
  <li>Real-time lead sync into PUG CRM</li>
  <li>Map campaigns, sources, and ownership</li>
  <li>Improve lead tracking and conversion efficiency</li>
</ul>
`,
      howItWorks: {
        description:"Follow the step-by-step process below to seamlessly integrate Moplet with your application, enabling efficient data flow and process automation.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → MoPlate Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter MoPlate account credentials or API key provided by MoPlate",
          "Navigate to 'Connected Accounts' section and verify connection",
          "Select Campaign, Source, and Owner for lead mapping",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, Email, and enquiry details",
          "Map additional fields like Campaign, Source, Product/Service, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        sync: [
          "Enable automatic lead sync for real-time data transfer",
          "Configure how leads should be created in PUG CRM",
          "Verify that incoming leads are being captured correctly",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Ensure your MoPlate account is active and properly configured",
          "Data sync depends on correct API and account setup",
          "You can manage all leads from the Lead Listing section in PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "whatzapi",
    name: "Whatzapi",
    path: "/settings/integration/whatzapi",
    category: "Business Whatsapp",
    description: "Deliver timely, informative WhatsApp messages with ease.",
    logo: whatzapi,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The WhatzAPI Integration enables you to connect your WhatsApp account with PUG CRM and manage customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  WhatzAPI is a WhatsApp messaging API platform that allows businesses to send automated messages, notifications, and campaigns. With this integration, you can engage with leads and customers on WhatsApp without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline communication, improve response time, and automate follow-ups, ensuring better customer engagement and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send WhatsApp messages directly from PUG CRM</li>
  <li>Automate notifications and follow-ups</li>
  <li>Engage leads in real-time via WhatsApp</li>
  <li>Track communication and improve conversions</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of WhatzAPI with your application, allowing you to automate WhatsApp messages, manage conversations, and streamline customer interactions.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → WhatzAPI Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your WhatzAPI API key and instance details",
          "Connect your WhatsApp number with WhatzAPI",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Configure automated WhatsApp messages for new leads or events",
          "Set up message templates for notifications and follow-ups",
          "Trigger messages based on actions like lead creation or status change",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send WhatsApp messages directly using WhatzAPI integration",
          "Use templates for quick communication",
          "Track message delivery and responses",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed message attempts",
          "Monitor communication performance",
        ],

        note: [
          "Ensure your WhatzAPI account and WhatsApp instance are active",
          "Message delivery depends on WhatsApp API configuration",
          "You can manage all communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "tubelight",
    name: "Tubelight Whatsapp",
    path: "/settings/integration/tubelight",
    category: "Communication Platform",
    description:
      "Everything you need to start, run, and grow your business — in one place.",
    logo: Tubelight_Logo,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Tubelight WhatsApp Integration enables you to connect your WhatsApp Business account with PUG CRM and manage customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Tubelight is a WhatsApp communication platform that allows businesses to send automated messages, campaigns, and notifications at scale. With this integration, you can engage with leads and customers on WhatsApp without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline communication, improve response time, and automate follow-ups, ensuring better customer engagement and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send WhatsApp messages directly from PUG CRM</li>
  <li>Automate notifications and follow-ups</li>
  <li>Run WhatsApp campaigns for lead engagement</li>
  <li>Track message delivery and response performance</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Tubelight WhatsApp with your application, allowing you to automate WhatsApp messages, manage conversations, and streamline customer interactions.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Tubelight WhatsApp Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Tubelight API key and account details",
          "Connect your WhatsApp Business number with Tubelight",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Set up automated WhatsApp messages for new leads or events",
          "Configure message templates for notifications and campaigns",
          "Trigger messages based on actions like lead creation, assignment, or follow-ups",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send WhatsApp messages directly using Tubelight integration",
          "Use pre-approved templates for communication",
          "Track message delivery and engagement",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed message attempts",
          "Monitor campaign and communication performance",
        ],

        note: [
          "Ensure your WhatsApp Business account is active and connected",
          "Message templates must be approved before sending campaigns",
          "You can manage all WhatsApp communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "green&global",
    name: "Green Ads Global",
    path: "/settings/integration/green&global",
    category: "Business Whatsapp",
    description: "Deliver timely, informative WhatsApp messages effortlessly.",
    logo: GreenAdsGlobal,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Green & Global Integration enables you to capture and sync leads, enquiries, and customer data from the Green & Global platform directly into PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Green & Global is a platform that supports businesses in managing customer interactions, campaigns, and lead generation across multiple channels. With this integration, all incoming data is seamlessly transferred into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This eliminates manual data entry, improves operational efficiency, and helps your team manage and convert leads effectively from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automatically capture leads and enquiries from Green & Global</li>
  <li>Real-time data sync into PUG CRM</li>
  <li>Map campaigns, sources, and ownership</li>
  <li>Improve lead tracking and conversion efficiency</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Green Ads Global with your application, allowing you to capture leads, monitor campaign performance, and streamline your advertising workflow.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Green & Global Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter Green & Global account credentials or API details provided by the platform",
          "Navigate to 'Connected Accounts' section and verify connection",
          "Select Campaign, Source, and Owner for lead mapping",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, Email, and enquiry details",
          "Map additional fields like Campaign, Source, Product/Service, and Owner",
          "Ensure correct field types to avoid data mismatch",
        ],

        sync: [
          "Enable automatic sync for real-time data transfer",
          "Configure how leads and data should be created in PUG CRM",
          "Verify that incoming data is being captured correctly",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View all incoming leads and their status",
          "Check error logs for failed entries",
          "Use logs to monitor integration performance",
        ],

        note: [
          "Ensure your Green & Global account is active and properly configured",
          "Data sync depends on correct API and account setup",
          "You can manage all leads and customer data from PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "gupshup",
    name: "Gupshup",
    path: "/settings/integration/gupshup",
    category: "Business Whatsapp",
    description: "Send and receive messages on time with a dependable SMS API.",
    logo: gupshup,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Gupshup Integration enables you to connect your WhatsApp Business API account with PUG CRM and manage customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Gupshup is a leading conversational messaging platform that allows businesses to send WhatsApp, SMS, and other messaging communications at scale. With this integration, you can engage with leads and customers across multiple channels without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline communication, automate follow-ups, and improve response time, resulting in better customer engagement and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send WhatsApp and SMS messages directly from PUG CRM</li>
  <li>Automate notifications and follow-ups</li>
  <li>Run messaging campaigns for lead engagement</li>
  <li>Track delivery status and communication performance</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Gupshup with your application, allowing you to automate conversations, manage customer interactions, and streamline communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Gupshup Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Gupshup API key, App Name, and channel details",
          "Connect your WhatsApp Business account with Gupshup",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Configure automated messages for new leads or events",
          "Set up message templates for WhatsApp and SMS",
          "Trigger communication based on actions like lead creation, assignment, or status change",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send messages directly using Gupshup integration",
          "Use approved templates for communication",
          "Track delivery status and responses",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed message attempts",
          "Monitor communication and campaign performance",
        ],

        note: [
          "Ensure your Gupshup account is active and properly configured",
          "Message templates must be approved for WhatsApp communication",
          "Multi-channel messaging depends on enabled services in Gupshup",
          "You can manage all communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "twillo",
    name: "Twilio",
    path: "/integration/twillo",
    category: "Business Whatsapp",
    description:
      "Deliver personalized WhatsApp messages in real time using customer data.",
    logo: Twilio,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Twilio Integration enables you to connect your Twilio account with PUG CRM and manage multi-channel customer communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Twilio is a global cloud communication platform that allows businesses to send SMS, WhatsApp messages, emails, and even handle voice calls through APIs. With this integration, you can engage with leads and customers across multiple channels without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps automate communication workflows, improve response time, and deliver personalized customer experiences, resulting in higher engagement and better conversions.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send SMS, WhatsApp messages, and emails from PUG CRM</li>
  <li>Automate communication workflows and notifications</li>
  <li>Enable voice call integration for customer interactions</li>
  <li>Track delivery status and communication performance</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Twilio with your application, allowing you to send SMS, manage voice interactions, and automate customer communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Twilio Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Twilio Account SID and Auth Token",
          "Configure your Twilio phone number or sender details",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure phone number is correctly mapped for messaging and calling",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Set up automated communication workflows for leads",
          "Send SMS, WhatsApp, or email notifications based on events",
          "Configure triggers for actions like lead creation, assignment, or follow-ups",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send SMS or WhatsApp messages using Twilio",
          "Initiate calls directly if voice is enabled",
          "Track communication history and responses",
        ],

        logs: [
          "Navigate to the 'Communication Logs' or 'Activity Logs' section",
          "View sent messages, calls, and delivery status",
          "Check errors or failed communication attempts",
          "Monitor performance across all channels",
        ],

        note: [
          "Ensure your Twilio account is active and properly configured",
          "Charges may apply based on Twilio usage (SMS, calls, WhatsApp)",
          "WhatsApp messaging requires approved templates",
          "You can manage all communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "gallabox",
    name: "Gallabox",
    path: "/settings/integration/gallabox",
    category: "Business Whatsapp",
    description:
      "Enable seamless collaboration with consistent WhatsApp messaging.",
    logo: gallabox,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The GallaBox Integration enables you to connect your WhatsApp Business account with PUG CRM and manage customer conversations directly from a shared team inbox.
</p>

<p style="margin-bottom:12px !important;">
  GallaBox is a WhatsApp-based communication and collaboration platform that allows teams to manage conversations, automate responses, and run campaigns. With this integration, you can handle all customer interactions seamlessly within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve team collaboration, automate follow-ups, and deliver faster responses, resulting in better customer engagement and higher conversion rates.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Manage WhatsApp conversations from a shared team inbox</li>
  <li>Send and receive messages directly from PUG CRM</li>
  <li>Automate responses and follow-ups</li>
  <li>Assign chats to team members for better collaboration</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Gallabox with your application, allowing you to automate conversations, manage customer interactions, and streamline communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → GallaBox Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your GallaBox API key or connect your GallaBox account",
          "Connect your WhatsApp Business number with GallaBox",
          "Save the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure WhatsApp number is correctly mapped for messaging",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Set up automated replies and chatbot flows",
          "Configure message templates for follow-ups and notifications",
          "Trigger messages based on events like new lead creation or assignment",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send and receive WhatsApp messages using GallaBox",
          "Assign conversations to team members",
          "Track conversation history and responses",
        ],

        logs: [
          "Navigate to the 'Message Logs' or 'Activity Logs' section",
          "View all conversations and delivery status",
          "Check errors or failed message attempts",
          "Monitor team performance and response times",
        ],

        note: [
          "Ensure your WhatsApp Business account is active and connected",
          "Message templates must be approved before sending campaigns",
          "You can manage all conversations and team assignments within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "myoperator",
    name: "MyOperator",
    path: "/settings/integration/myoperator",
    category: "IVR and Cloud Telephony",
    description: "Boost customer engagement using seamless cloud telephony.",
    logo: MyOperator,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MyOperator Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  MyOperator is a cloud-based call management platform that helps businesses handle incoming and outgoing calls, track conversations, and manage customer communication efficiently. With this integration, all call activities are seamlessly recorded in PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve lead tracking, ensures no call is missed, and allows your team to follow up effectively using real-time call insights within the CRM.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign calls and leads to relevant users</li>
  <li>Improve follow-ups with call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of MyOperator with your application, allowing you to manage calls, track customer interactions, and streamline your communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → MyOperator Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your MyOperator API key and account credentials",
          "Configure your MyOperator number and call settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct field mapping for accurate lead creation",
        ],

        automation: [
          "Configure automatic lead creation for incoming calls",
          "Set up call-based triggers such as missed call alerts or follow-ups",
          "Assign leads automatically based on call routing or rules",
        ],

        usage: [
          "Receive calls through your MyOperator number",
          "Automatically create leads in PUG CRM for each call",
          "View call logs and customer interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status and details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your MyOperator account is active and properly configured",
          "Call data sync depends on correct API and number configuration",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "krispCall",
    name: "KrispCall",
    path: "/settings/integration/krispCall",
    category: "Calling",
    description:
      "Integrate Kylas CRM with KrispCall to supercharge your sales interactions.",
    logo: krispcall,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Krishpa Call Integration enables you to connect your call management system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Krishpa Call is a cloud telephony platform that helps businesses manage incoming and outgoing calls, track customer conversations, and streamline communication workflows. With this integration, all call activities are seamlessly recorded in PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Automatically assign leads based on call routing</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of KrispCall with your application, allowing you to manage calls, track interactions, and streamline your communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Krishpa Call Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Krishpa Call API key and account credentials",
          "Configure your call tracking number and routing settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming calls",
          "Set up triggers for missed calls and follow-up actions",
          "Assign leads automatically based on call routing or business rules",
        ],

        usage: [
          "Receive calls through your Krishpa Call number",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Krishpa Call account is active and properly configured",
          "Call data sync depends on correct API and number configuration",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "callhippo",
    name: "Call Hippo",
    path: "/settings/integration/callhippo",
    category: "Click-to-Call Software",
    description: "Smart Click-to-Call Solution.",
    logo: callHippo,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The CallHippo Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  CallHippo is a cloud-based business phone system that allows teams to manage calls, track conversations, and analyze call performance. With this integration, all call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve lead tracking, ensures no call is missed, and allows your team to manage and follow up with leads efficiently using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Monitor call performance and analytics</li>
  <li>Assign leads to agents for faster follow-up</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of CallHippo with your application, allowing you to manage calls, track interactions, and streamline your communication workflows.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → CallHippo Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your CallHippo API key and account credentials",
          "Configure your CallHippo number and call settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct field mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up triggers for missed calls and follow-up reminders",
          "Assign leads automatically based on call routing or rules",
        ],

        usage: [
          "Receive or make calls using CallHippo",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, recordings, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and recordings",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your CallHippo account is active and properly configured",
          "Call recordings and analytics depend on your CallHippo plan",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  //   {
  //     name: "Kylas Dialer",
  //     path: "/integration/google_ads",
  //     category: "Click-to-Call Software",
  //     description:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard ",
  //     logo: email,
  //   },
  {
    id: "tataTele",
    name: "Tata Tele Business Services",
    path: "/settings/integration/tataTele",
    category: "Click-to-Call Software",
    description: "Smart Click-to-Call Solution.",
    logo: TataTele,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Tata Tele Integration enables you to connect your enterprise telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Tata Tele is a trusted business communication provider offering cloud telephony and call management solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve call tracking, ensures no lead is missed, and allows your team to efficiently manage customer interactions and follow-ups from a centralized CRM platform.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign leads based on call routing and business rules</li>
  <li>Improve follow-ups using real-time call insights</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Tata Tele Business Services with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Tata Tele Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter Tata Tele API credentials or account details provided by Tata Tele",
          "Configure your telephony numbers and call routing settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct field mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up triggers for missed calls and follow-up actions",
          "Assign leads automatically based on routing or business rules",
        ],

        usage: [
          "Receive and manage calls through Tata Tele system",
          "Automatically create leads in PUG CRM for each call",
          "View call logs and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Tata Tele account is active and properly configured",
          "Call data sync depends on correct API and telephony setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "voxbay",
    name: "Voxbay",
    path: "/settings/integration/voxbay",
    category: "Cloud-Based Call Management Solution",
    description: "Connect all your offices effortlessly using cloud telephony.",
    logo: voxbay,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Voxbay Integration enables you to connect your cloud telephony and IVR system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Voxbay is a cloud-based communication platform that provides IVR, call tracking, and call management solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps ensure no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data and IVR insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track IVR responses and call logs in PUG CRM</li>
  <li>Assign leads based on IVR routing and call flow</li>
  <li>Improve follow-ups using call insights and interaction history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Voxbay with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Voxbay Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Voxbay API credentials or account details",
          "Configure IVR flow and telephony numbers",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, IVR input, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive calls through Voxbay IVR system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs and IVR responses",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls with IVR details",
          "Check call status and interaction data",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Voxbay account is active and IVR is properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "bigVtelecom",
    name: "Big V Telecom",
    path: "/settings/integration/bigVtelecom",
    category: "Simpler Affordable Telephony Solutions",
    description:
      "Voice solutions designed for customers, results, and efficiency.",
    logo: BigVTelecom,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The BigV Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  BigV is a business communication platform that provides call management, IVR, and telephony solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps ensure no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign leads based on call routing and IVR flow</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of BigV Telecom with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → BigV Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your BigV API credentials or account details",
          "Configure your telephony number and IVR settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive and manage calls using BigV system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your BigV account is active and properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "callerdesk",
    name: "CallerDesk",
    path: "/settings/integration/callerdesk",
    category: "Cloud Telephony ",
    description:
      "Launch voice communications instantly with a ready-to-use business platform.",
    logo: callerDesk,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The CallerDesk Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  CallerDesk is a cloud communication platform that provides IVR, call tracking, and call management solutions for businesses. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data and IVR insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR responses in PUG CRM</li>
  <li>Assign leads based on call routing and IVR flow</li>
  <li>Improve follow-ups using call insights and interaction history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of CallerDesk with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → CallerDesk Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your CallerDesk API credentials or account details",
          "Configure your telephony numbers and IVR settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive calls through CallerDesk IVR system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls with IVR details",
          "Check call status, duration, and interaction data",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your CallerDesk account is active and properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "daildesk",
    name: "DialDesk",
    path: "/settings/integration/daildesk",
    category: "Cloud-Based Contact Center Solution",
    description:
      "Deliver exceptional inbound and outbound support that delights customers.",
    logo: DIALDESK,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The DialDesk Integration enables you to connect your cloud telephony and contact center system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  DialDesk is a cloud-based contact center platform that provides call handling, IVR, and customer support solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer interaction tracking, ensures no lead is missed, and allows your team to efficiently manage and follow up with leads using real-time call data and insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign leads based on call routing and IVR flow</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of DialDesk with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → DialDesk Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your DialDesk API credentials or account details",
          "Configure your telephony numbers and IVR settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive and manage calls through DialDesk contact center",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your DialDesk account is active and properly configured",
          "Call data sync depends on correct API and telephony setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "tubelight_caller",
    name: "Tubelight Caller",
    path: "/settings/integration/tubelight_caller",
    category: "Conversational Powered Customer Engagement Platform",
    description:
      "Reach, engage, and enhance customer experiences across channels.",
    logo: Tubelight_Logo,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Tubelight Caller Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Tubelight Caller is a business communication platform that helps manage incoming and outgoing calls, track conversations, and streamline call workflows. With this integration, all call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign leads based on call routing</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Tubelight Caller with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Tubelight Caller Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Tubelight Caller API credentials or account details",
          "Configure your telephony number and call routing settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up triggers for missed calls and follow-ups",
          "Assign leads automatically based on routing or business rules",
        ],

        usage: [
          "Receive and manage calls using Tubelight Caller",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Tubelight Caller account is active and properly configured",
          "Call data sync depends on correct API and telephony setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "servetel",
    name: "Servetel",
    path: "/settings/integration/servetel",
    category: "IVR and Cloud Telephony ",
    description:
      "Reliable cloud communication systems built for efficient interactions.",
    logo: servetel,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Servetel Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Servetel is a cloud communication platform that provides IVR, call tracking, and call management solutions for businesses. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Assign leads based on call routing and IVR flow</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"Getting started with Servetel integration is simple—follow the steps below to connect your application and start managing calls and customer interactions effortlessly.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Servetel Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Servetel API credentials or account details",
          "Configure your telephony numbers and IVR settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive calls through Servetel IVR system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Servetel account is active and properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "knowlarity",
    name: "Knowlarity",
    path: "/settings/integration/knowlarity",
    category: "IVR and Cloud Telephony",
    description:
      "Scale customer engagement effortlessly with efficient calling solutions.",
    logo: Knowlarity,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Knowlarity Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Knowlarity is a leading cloud communication platform that provides IVR, call tracking, and call automation solutions for businesses. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data and automation.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Automate call routing and lead assignment</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Knowlarity with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Knowlarity Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Knowlarity API credentials or account details",
          "Configure your telephony numbers and IVR settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Configure automated call flows and follow-up triggers",
        ],

        usage: [
          "Receive calls through Knowlarity IVR system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Knowlarity account is active and properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "ozonetel",
    name: "Ozonetel",
    path: "/settings/integration/ozonetel",
    category: "IVR and Cloud Telephony",
    description:
      "Cloud-native telephony solutions designed for stronger engagement.",
    logo: Ozonetel,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Ozonetel Integration enables you to connect your cloud contact center and telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Ozonetel is an advanced cloud communication platform that provides IVR, call center solutions, and customer interaction management tools. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer engagement, ensures no lead is missed, and allows your team to efficiently manage calls, track performance, and follow up using real-time data.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Assign leads based on call routing and agent availability</li>
  <li>Improve follow-ups using call insights and analytics</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Ozonetel with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Ozonetel Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Ozonetel API credentials or account details",
          "Configure your telephony numbers, IVR flows, and agent settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and agent assignment",
          "Trigger follow-up actions based on call outcomes and status",
        ],

        usage: [
          "Handle calls through Ozonetel contact center",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and agent interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, IVR data, and agent performance",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Ozonetel account is active and properly configured",
          "Call and IVR data sync depends on correct API and setup",
          "You can manage all call-based leads and interactions within PUG CRM",
          "Advanced features like analytics and reporting depend on your Ozonetel plan",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "exotel",
    name: "Exotel",
    path: "/settings/integration/exotel",
    category: "IVR and Cloud Telephony",
    description:
      "Build stronger customer relationships using advanced calling solutions.",
    logo: Exotel,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Exotel Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Exotel is a leading cloud communication platform that provides IVR, call tracking, and call automation solutions for businesses. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call data and automation.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Automate call routing and lead assignment</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Exotel with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Exotel Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Exotel Account SID, API Key, and API Token",
          "Configure your Exotel number and IVR flow settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Configure automated call workflows and follow-up triggers",
        ],

        usage: [
          "Receive and manage calls using Exotel system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Exotel account is active and properly configured",
          "Call and IVR data sync depends on correct API credentials and setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "mcube",
    name: "Mcube",
    path: "/settings/integration/mcube",
    category: "IVR and Cloud Telephony",
    description: "Lead the way with next-gen telephony solutions.",
    logo: Mcube,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MCube Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  MCube is a cloud-based communication platform that provides IVR, call tracking, and call management solutions for businesses. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Assign leads based on call routing and IVR flow</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of MCube with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → MCube Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your MCube API credentials or account details",
          "Configure your telephony numbers and IVR flow settings",
          "Save the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and IVR inputs",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and lead assignment",
          "Trigger follow-up actions based on call outcomes",
        ],

        usage: [
          "Receive and manage calls using MCube system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your MCube account is active and properly configured",
          "Call and IVR data sync depends on correct API setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "tatatele",
    name: "Tata Tele",
    path: "/settings/integration/tatatele",
    category: "IVR and Cloud Telephony",
    description:
      "Power better communication with enterprise-grade cloud infrastructure.",
    logo: TataTele,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Tata Tele Integration enables you to connect your enterprise telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Tata Tele is a trusted business communication provider offering cloud telephony, IVR, and call management solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve call tracking, ensures no lead is missed, and allows your team to efficiently manage customer interactions and follow-ups using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and IVR interactions in PUG CRM</li>
  <li>Automate call routing and lead assignment</li>
  <li>Improve follow-ups using real-time call data</li>
</ul>
`,
      howItWorks: {
        description:"This section outlines the step-by-step process to integrate Tata Tele Business Services APIs into your application, ensuring secure call handling, IVR configuration, webhook integration, and reliable communication tracking.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Tata Tele Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter Tata Tele API credentials or account details provided by Tata Tele",
          "Configure telephony numbers and IVR routing settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map IVR inputs and additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up IVR-based routing and automatic lead assignment",
          "Configure follow-up triggers for missed or completed calls",
        ],

        usage: [
          "Receive and manage calls using Tata Tele system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, IVR responses, and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and IVR interaction details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Tata Tele account is active and properly configured",
          "Call data sync depends on correct API credentials and telephony setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "aircall",
    name: "Aircall",
    path: "/settings/integration/aircall",
    category: "IVR and Cloud Telephony",
    description:
      "An efficient, easy-to-use cloud voice platform for phone support.",
    logo: aircall,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Aircall Integration enables you to connect your cloud-based phone system with PUG CRM and automatically capture call activities and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Aircall is a modern cloud telephony platform designed for sales and support teams, offering call management, call routing, and real-time collaboration features. With this integration, all call activities are seamlessly logged within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve team productivity, ensures better call tracking, and allows your team to manage customer interactions efficiently with real-time insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Enable smart call routing and team collaboration</li>
  <li>Improve follow-ups using real-time call insights</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Aircall with your application, allowing you to manage calls, implement IVR workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Aircall Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Aircall API ID and API Token",
          "Configure your Aircall phone numbers and team settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, Call Details, and Tags",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up call routing and team assignment rules",
          "Trigger follow-up actions based on call outcomes and tags",
        ],

        usage: [
          "Make and receive calls using Aircall",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs, notes, tags, and conversation history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, notes, and tags",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Aircall account is active and properly configured",
          "API access must be enabled in your Aircall account",
          "You can manage all call-based leads and interactions within PUG CRM",
          "Advanced features like analytics and integrations depend on your Aircall plan",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "kaleyra",
    name: "Kaleyra",
    path: "/settings/integration/kaleyra",
    category: "API-based Calling Solutions ",
    description:
      "Advanced calling solutions that drive rich communication and retention.",
    logo: kaleyra,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Kaleyra Integration enables you to connect your communication platform with PUG CRM and manage multi-channel customer engagement directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Kaleyra is a global communication platform that allows businesses to send SMS, WhatsApp messages, voice alerts, and notifications. With this integration, you can engage with leads and customers across multiple channels without leaving PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps automate communication workflows, improve response time, and deliver personalized customer experiences, resulting in higher engagement and better conversions.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send SMS, WhatsApp messages, and voice notifications from PUG CRM</li>
  <li>Automate communication workflows and alerts</li>
  <li>Engage leads with personalized messaging</li>
  <li>Track delivery status and communication performance</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Kaleyra with your application, allowing you to manage communications, implement messaging and calling workflows, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Kaleyra Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Kaleyra API key, SID, and base URL",
          "Configure communication channels such as SMS, WhatsApp, and Voice",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Phone Number, and Email",
          "Ensure correct mapping for messaging channels",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Set up automated communication workflows for leads",
          "Send SMS, WhatsApp, or voice alerts based on events",
          "Trigger messages for actions like lead creation, assignment, or follow-ups",
        ],

        usage: [
          "Open any Lead or Contact in PUG CRM",
          "Send messages or alerts using Kaleyra",
          "Use templates for consistent communication",
          "Track delivery status and responses",
        ],

        logs: [
          "Navigate to the 'Communication Logs' or 'Activity Logs' section",
          "View sent messages and delivery status",
          "Check errors or failed communication attempts",
          "Monitor performance across channels",
        ],

        note: [
          "Ensure your Kaleyra account is active and properly configured",
          "Charges may apply based on SMS, WhatsApp, or voice usage",
          "Templates must be approved for WhatsApp communication",
          "You can manage all communication directly within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "bonoice",
    name: "Bonvoice",
    path: "/settings/integration/bonoice",
    category: "IVR and Cloud Telephony",
    description:
      "Scalable cloud communication and expert consulting for IoT manufacturers.",
    logo: Bonvoice,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Bonvoice Integration enables you to connect your cloud telephony system with PUG CRM and automatically capture call-based leads and customer interactions.
</p>

<p style="margin-bottom:12px !important;">
  Bonvoice is a business communication platform that provides call tracking, call management, and telephony solutions. With this integration, all incoming and outgoing call activities are seamlessly recorded within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps ensure that no call is missed, improves response time, and allows your team to efficiently manage and follow up with leads using real-time call insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture leads from incoming and outgoing calls</li>
  <li>Track call logs and customer interactions in PUG CRM</li>
  <li>Assign leads based on call routing and business rules</li>
  <li>Improve follow-ups using call insights and history</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Bonvoice with your application, enabling you to manage calls, implement IVR workflows, automate customer communication, track interactions in real time, and streamline your overall communication processes through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → Bonvoice Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your Bonvoice API credentials or account details",
          "Configure your telephony number and call settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Caller Name, Phone Number, and Call Details",
          "Map additional fields like Campaign, Source, and Owner",
          "Ensure correct mapping for accurate lead creation",
        ],

        automation: [
          "Enable automatic lead creation for incoming and outgoing calls",
          "Set up triggers for missed calls and follow-ups",
          "Assign leads automatically based on routing or business rules",
        ],

        usage: [
          "Receive and manage calls using Bonvoice system",
          "Automatically create leads in PUG CRM for each interaction",
          "View call logs and interaction history",
          "Follow up with leads directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Call Logs' or 'Activity Logs' section",
          "View all incoming and outgoing calls",
          "Check call status, duration, and details",
          "Monitor missed calls and follow-up actions",
        ],

        note: [
          "Ensure your Bonvoice account is active and properly configured",
          "Call data sync depends on correct API credentials and setup",
          "You can manage all call-based leads and interactions within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "cloudshopee",
    name: "Cloudshopee",
    path: "/settings/integration/cloudshopee",
    category: "IVR and Cloud Telephony",
    description:
      "Manage, measure, and automate business communications end to end.",
    logo: CloudShopee,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The CloudShopee Integration enables you to connect your e-commerce platform with PUG CRM and automatically capture orders, customer details, and leads.
</p>

<p style="margin-bottom:12px !important;">
  CloudShopee is an e-commerce platform that helps businesses manage online stores, orders, and customer data. With this integration, all customer enquiries and order details are seamlessly synced into PUG CRM in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve order tracking, customer management, and follow-ups, allowing your team to manage sales and support from a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Capture orders and customer data from CloudShopee</li>
  <li>Sync leads and enquiries into PUG CRM</li>
  <li>Track customer interactions and order history</li>
  <li>Improve follow-ups and customer engagement</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Cloudshopee with your application, enabling you to manage customer communications, automate messaging workflows, track interactions in real time, and streamline engagement processes through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → CloudShopee Integration",
          "Log in to the application",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key and save",
          "Enter your CloudShopee API credentials or store details",
          "Connect your CloudShopee account with PUG CRM",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Phone Number, Email, and Address",
          "Map order details like Product, Amount, and Order Status",
          "Map additional fields like Campaign, Source, and Owner",
        ],

        automation: [
          "Enable automatic lead and order sync",
          "Create leads or contacts when a new order is placed",
          "Trigger follow-up actions based on order status",
        ],

        usage: [
          "Receive orders and customer enquiries from CloudShopee",
          "Automatically create leads and contacts in PUG CRM",
          "View order history and customer details",
          "Follow up with customers directly from the CRM",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View all incoming orders and customer data",
          "Check sync status and errors",
          "Monitor integration performance",
        ],

        note: [
          "Ensure your CloudShopee account is active and properly configured",
          "Data sync depends on correct API credentials and setup",
          "You can manage all orders and customer data within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "msTeamsNotifier",
    name: "MS Teams Notifier",
    path: "/settings/integration/msTeamsNotifier",
    category: "Cloud-Based Collaboration App",
    description:
      "Work better together with a faster, simpler, and smarter Teams.",
    logo: Teams,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MS Teams Notifier Integration enables you to receive real-time CRM notifications directly in Microsoft Teams, helping your team stay updated without switching platforms.
</p>

<p style="margin-bottom:12px !important;">
  Microsoft Teams is a collaboration platform that allows teams to communicate, share updates, and manage workflows efficiently. With this integration, important CRM events such as lead creation, updates, and activities are instantly pushed to your Teams channels.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves team collaboration, ensures faster response time, and keeps everyone aligned with real-time updates from PUG CRM.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Receive real-time notifications in Microsoft Teams</li>
  <li>Stay updated on lead creation and activity changes</li>
  <li>Improve team collaboration and visibility</li>
  <li>Reduce delays in follow-ups and communication</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Microsoft Teams Notifier with your application, enabling you to send real-time notifications, alerts, and updates directly to your Teams channels, helping your team stay informed and respond quickly through a centralized communication system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up using your email and verify your account",
          "Navigate to Marketplace → Installed Apps → MS Teams Notifier",
          "Log in to the application",
        ],

        setup: [
          "Go to the Webhook or Integration settings section",
          "Enter your PUG CRM API key if required",
          "Create an Incoming Webhook in your Microsoft Teams channel",
          "Copy the Webhook URL from Teams",
          "Paste the Webhook URL into the application and save",
        ],

        mapping: [
          "Select events such as Lead Creation, Update, or Assignment",
          "Map notification format and message content",
          "Choose Teams channel where notifications will be sent",
        ],

        automation: [
          "Enable automatic notifications for selected CRM events",
          "Trigger alerts when new leads are created or updated",
          "Notify team members instantly for important actions",
        ],

        usage: [
          "Perform actions in PUG CRM (e.g., create or update a lead)",
          "Receive instant notifications in your Teams channel",
          "Collaborate with team members directly in Teams",
          "Take quick actions based on CRM updates",
        ],

        logs: [
          "Navigate to the 'Notification Logs' section",
          "View sent notifications and delivery status",
          "Check failed webhook deliveries",
          "Monitor notification activity",
        ],

        note: [
          "Ensure your Microsoft Teams webhook is active and properly configured",
          "Notification delivery depends on correct webhook setup",
          "You can customize notifications based on CRM events",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },

  {
    id: "mailchimp",
    name: "Mailchimp",
    path: "/settings/integration/mailchimp",
    category: "Email Marketing",
    description: "Convert emails into revenue with smarter email marketing.",
    logo: mailchimp,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Mailchimp Integration enables you to connect your email marketing platform with PUG CRM and manage audience engagement directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Mailchimp is a popular email marketing platform that allows businesses to create campaigns, manage audiences, and automate email communication. With this integration, you can sync contacts and leads from PUG CRM to Mailchimp and run targeted campaigns.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer engagement, automate email workflows, and track campaign performance, resulting in better lead nurturing and conversions.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync leads and contacts with Mailchimp audiences</li>
  <li>Create and manage email campaigns</li>
  <li>Automate email workflows and follow-ups</li>
  <li>Track campaign performance and engagement</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Mailchimp with your application, enabling you to manage email campaigns, automate marketing workflows, sync audience data, and track engagement metrics through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up or log in using your Mailchimp account",
          "Navigate to Marketplace → Installed Apps → Mailchimp Integration",
          "Authorize access to your Mailchimp account",
        ],

        setup: [
          "Go to the API Keys or Authentication section",
          "Enter your PUG CRM API key if required",
          "Enter your Mailchimp API key",
          "Select your Mailchimp audience (list) to sync contacts",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map CRM fields such as Name, Email, Phone Number",
          "Map custom fields like Campaign, Source, Tags",
          "Ensure correct field mapping for audience segmentation",
        ],

        automation: [
          "Enable automatic sync of leads and contacts",
          "Trigger email campaigns based on CRM events",
          "Set up automated email journeys for lead nurturing",
        ],

        usage: [
          "Add or update leads in PUG CRM",
          "Automatically sync contacts to Mailchimp audience",
          "Create and send campaigns from Mailchimp",
          "Track engagement such as opens and clicks",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View synced contacts and campaign activity",
          "Check errors or failed sync attempts",
          "Monitor email engagement performance",
        ],

        note: [
          "Ensure your Mailchimp account is active and API key is valid",
          "Email sending limits depend on your Mailchimp plan",
          "You can manage all contacts and campaigns from Mailchimp dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "outlook",
    name: "Outlook",
    path: "/settings/integration/outlook",
    category: "Email Integration",
    description: "Manage every email effortlessly with MS Outlook.",
    logo: outlook,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Outlook Integration enables you to connect your Microsoft Outlook account with PUG CRM and manage email communication directly from the CRM.
</p>

<p style="margin-bottom:12px !important;">
  Microsoft Outlook is a widely used email and productivity platform that helps businesses manage emails, calendars, and contacts. With this integration, you can sync emails, track conversations, and associate them with leads and contacts in PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve communication tracking, ensures better follow-ups, and allows your team to manage customer interactions efficiently from a centralized platform.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync emails between Outlook and PUG CRM</li>
  <li>Track email conversations with leads and contacts</li>
  <li>Log emails automatically in CRM records</li>
  <li>Improve follow-ups and communication visibility</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Outlook with your application, enabling you to send and receive emails, manage contacts and calendars, automate communication workflows, and streamline your email operations through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Microsoft Outlook account",
          "Navigate to Marketplace → Installed Apps → Outlook Integration",
          "Authorize access to your Outlook account",
        ],

        setup: [
          "Complete OAuth authentication with your Microsoft account",
          "Grant required permissions for email and contacts access",
          "Select mailbox and sync preferences",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map email fields such as Sender, Receiver, Subject, and Content",
          "Associate emails with Leads, Contacts, and Deals in PUG CRM",
          "Map additional fields if required for tracking",
        ],

        automation: [
          "Enable automatic email logging in CRM",
          "Trigger follow-up actions based on email activity",
          "Sync incoming and outgoing emails in real-time",
        ],

        usage: [
          "Send or receive emails via Outlook",
          "Automatically track emails in PUG CRM",
          "View email history inside Lead or Contact records",
          "Follow up with customers directly from CRM",
        ],

        logs: [
          "Navigate to the 'Email Logs' or 'Activity Logs' section",
          "View synced emails and communication history",
          "Check sync status and errors",
          "Monitor email tracking performance",
        ],

        note: [
          "Ensure your Microsoft account is active and permissions are granted",
          "Email sync depends on correct authentication setup",
          "You can manage all email communication within PUG CRM",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "mailjet",
    name: "Mailjet",
    path: "/settings/integration/mailjet",
    category: "Email Marketing",
    description: "Create, send, and track email performance with ease.",
    logo: Mailjet,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Mailjet Integration enables you to connect your email delivery platform with PUG CRM and manage both transactional and marketing emails efficiently.
</p>

<p style="margin-bottom:12px !important;">
  Mailjet is an email service provider that allows businesses to send transactional emails, run marketing campaigns, and track email performance. With this integration, you can send emails directly from PUG CRM and monitor engagement in real-time.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve communication reliability, automate email workflows, and enhance customer engagement through personalized messaging.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send transactional and marketing emails from PUG CRM</li>
  <li>Automate email notifications and workflows</li>
  <li>Track email delivery, opens, and clicks</li>
  <li>Manage email templates and campaigns</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Mailjet with your application, enabling you to send transactional and marketing emails, automate email workflows, manage contact lists, and track delivery and engagement metrics through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up or log in using your Mailjet account",
          "Navigate to Marketplace → Installed Apps → Mailjet Integration",
          "Authorize access to your Mailjet account",
        ],

        setup: [
          "Go to the API Keys section in Mailjet",
          "Enter your Mailjet API Key and Secret Key",
          "Enter your PUG CRM API key if required",
          "Configure sender email and domain settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Name, Email, and Contact details",
          "Map custom fields for personalization (e.g., Campaign, Source)",
          "Ensure proper field mapping for email targeting",
        ],

        automation: [
          "Set up automated email triggers for CRM events",
          "Send transactional emails like notifications or alerts",
          "Run automated marketing campaigns and follow-ups",
        ],

        usage: [
          "Create or update leads in PUG CRM",
          "Send emails using Mailjet integration",
          "Use templates for consistent communication",
          "Track email engagement such as opens and clicks",
        ],

        logs: [
          "Navigate to the 'Email Logs' or 'Activity Logs' section",
          "View sent emails and delivery status",
          "Check errors or failed email attempts",
          "Monitor campaign performance",
        ],

        note: [
          "Ensure your Mailjet account is active and API keys are valid",
          "Email delivery depends on domain authentication and sender setup",
          "You can manage templates and campaigns from Mailjet dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "zoho_book",
    name: "Zoho Books",
    path: "/settings/integration/zoho_book",
    category: "All-in-one payment platform",
    description:
      "Manage transactions effortlessly with secure, next-gen payment technology.",
    logo: zohobooks,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Zoho Books Integration enables you to connect your accounting system with PUG CRM and manage invoices, payments, and financial data seamlessly.
</p>

<p style="margin-bottom:12px !important;">
  Zoho Books is a cloud-based accounting platform that helps businesses manage invoices, expenses, payments, and financial reports. With this integration, you can sync customers, create invoices, and track payments directly from PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline financial operations, reduce manual work, and ensure accurate billing and payment tracking within your CRM.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Create and manage invoices directly from PUG CRM</li>
  <li>Sync customers and financial data with Zoho Books</li>
  <li>Track payments and invoice status</li>
  <li>Improve billing and financial visibility</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Zoho Books with your application, enabling you to manage invoices, track expenses, automate accounting workflows, synchronize financial data, and streamline your business finances through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Zoho Books account",
          "Navigate to Marketplace → Installed Apps → Zoho Books Integration",
          "Authorize access to your Zoho Books account",
        ],

        setup: [
          "Complete OAuth authentication with your Zoho account",
          "Select your Zoho Books organization",
          "Enter your PUG CRM API key if required",
          "Configure invoice and customer sync settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Email, Phone Number, and Address",
          "Map invoice fields like Amount, Tax, Status, and Due Date",
          "Map additional fields like Products/Services if required",
        ],

        automation: [
          "Enable automatic customer sync between PUG CRM and Zoho Books",
          "Automatically create invoices from deals or orders",
          "Trigger follow-up actions based on invoice status (paid/unpaid)",
        ],

        usage: [
          "Create or update customers in PUG CRM",
          "Generate invoices directly from CRM",
          "Track invoice status and payment details",
          "Manage financial records efficiently",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View synced customers and invoices",
          "Check errors or failed sync attempts",
          "Monitor financial data sync performance",
        ],

        note: [
          "Ensure your Zoho Books account is active and properly configured",
          "Data sync depends on correct authentication and organization selection",
          "You can manage all financial operations from Zoho Books dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "payu",
    name: "PayU",
    path: "/settings/integration/payu",
    category: "Online Payment Gateway",
    description: "Deliver seamless payments that power your business.",
    logo: PayU,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The PayU Integration enables you to connect your payment gateway with PUG CRM and manage transactions, payments, and customer billing efficiently.
</p>

<p style="margin-bottom:12px !important;">
  PayU is a leading payment gateway that allows businesses to accept online payments through multiple channels such as cards, UPI, net banking, and wallets. With this integration, you can track payments and link them directly to leads, contacts, or deals in PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline payment collection, improve financial tracking, and automate workflows based on payment status.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Accept and track online payments directly from PUG CRM</li>
  <li>Link payments to leads, contacts, or deals</li>
  <li>Monitor transaction status in real-time</li>
  <li>Automate actions based on payment events</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of PayU with your application, enabling you to process online payments securely, manage transactions, automate payment workflows, and track payment statuses through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up or log in using your PayU account",
          "Navigate to Marketplace → Installed Apps → PayU Integration",
          "Authorize access to your PayU account",
        ],

        setup: [
          "Go to the API Keys section in your PayU account",
          "Enter your Merchant Key and Salt (Secret Key)",
          "Enter your PUG CRM API key if required",
          "Configure payment settings and callback URLs",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Customer Name, Email, Phone Number",
          "Map transaction details like Amount, Payment Status, and Transaction ID",
          "Map additional fields like Campaign, Source, and Owner if required",
        ],

        automation: [
          "Enable automatic payment tracking and updates",
          "Trigger actions when payment is successful, failed, or pending",
          "Update deal or lead status based on payment events",
        ],

        usage: [
          "Generate payment links or initiate payments from PUG CRM",
          "Customers complete payment via PayU gateway",
          "Automatically track payment status in CRM",
          "Follow up based on payment activity",
        ],

        logs: [
          "Navigate to the 'Payment Logs' or 'Transaction Logs' section",
          "View all transactions and payment status",
          "Check failed or pending transactions",
          "Monitor payment performance",
        ],

        note: [
          "Ensure your PayU account is active and properly configured",
          "Payment processing depends on correct API credentials and setup",
          "Charges may apply based on PayU transaction fees",
          "You can manage detailed payment reports from PayU dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "stripe",
    name: "Stripe",
    path: "/settings/integration/stripe",
    category: "All-in-one payment platform",
    description:
      "Manage online transactions effortlessly with advanced payment infrastructure.",
    logo: stripe2,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Stripe Integration enables you to connect your payment gateway with PUG CRM and manage online payments, subscriptions, and billing seamlessly.
</p>

<p style="margin-bottom:12px !important;">
  Stripe is a global payment platform that allows businesses to accept payments, manage subscriptions, and handle billing across multiple countries. With this integration, you can track transactions and link them directly to leads, contacts, or deals in PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline payment collection, automate billing workflows, and improve financial tracking with real-time payment insights.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Accept online payments via cards, wallets, and international methods</li>
  <li>Manage subscriptions and recurring billing</li>
  <li>Track payment status and transaction history</li>
  <li>Automate workflows based on payment events</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Stripe with your application, enabling you to process online payments securely, manage subscriptions and transactions, automate billing workflows, and track payment activities through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign up or log in using your Stripe account",
          "Navigate to Marketplace → Installed Apps → Stripe Integration",
          "Authorize access to your Stripe account",
        ],

        setup: [
          "Go to the API Keys section in your Stripe dashboard",
          "Enter your Publishable Key and Secret Key",
          "Enter your PUG CRM API key if required",
          "Configure webhook endpoints for payment events",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map fields such as Customer Name, Email, Phone Number",
          "Map transaction details like Amount, Currency, Payment Status, and Transaction ID",
          "Map subscription details if using recurring billing",
        ],

        automation: [
          "Enable automatic payment tracking and updates",
          "Trigger actions when payment is successful, failed, or refunded",
          "Automate subscription billing and renewals",
          "Update deal or lead status based on payment events",
        ],

        usage: [
          "Generate payment links or invoices from PUG CRM",
          "Customers complete payments via Stripe",
          "Automatically track payment status in CRM",
          "Manage subscriptions and billing cycles",
        ],

        logs: [
          "Navigate to the 'Payment Logs' or 'Transaction Logs' section",
          "View all transactions, subscriptions, and payment status",
          "Check failed or pending payments",
          "Monitor payment and billing performance",
        ],

        note: [
          "Ensure your Stripe account is active and API keys are valid",
          "Webhook setup is required for real-time updates",
          "Charges may apply based on Stripe transaction fees",
          "You can manage detailed billing and reports from Stripe dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "quickbooks",
    name: "Quickbooks",
    path: "/settings/integration/quickbooks",
    category: "Digital accounting platform",
    description: "Streamline payments and invoicing with a powerful platform.",
    logo: QuickBooks,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The QuickBooks Integration enables you to connect your accounting system with PUG CRM and manage invoices, payments, and financial data seamlessly.
</p>

<p style="margin-bottom:12px !important;">
  QuickBooks is a widely used accounting platform that helps businesses manage invoices, expenses, payments, and financial reports. With this integration, you can sync customers, generate invoices, and track payments directly from PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps streamline financial operations, reduce manual work, and improve accuracy in billing and payment tracking.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Create and manage invoices directly from PUG CRM</li>
  <li>Sync customers and financial data with QuickBooks</li>
  <li>Track payments and invoice status</li>
  <li>Improve financial visibility and reporting</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of QuickBooks with your application, enabling you to manage invoices, track expenses, automate accounting workflows, synchronize financial data, and streamline your business finances through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your QuickBooks account",
          "Navigate to Marketplace → Installed Apps → QuickBooks Integration",
          "Authorize access to your QuickBooks account",
        ],

        setup: [
          "Complete OAuth authentication with your QuickBooks account",
          "Select your company file or organization",
          "Enter your PUG CRM API key if required",
          "Configure customer and invoice sync settings",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Email, Phone Number, and Address",
          "Map invoice fields like Amount, Tax, Status, and Due Date",
          "Map product or service details if required",
        ],

        automation: [
          "Enable automatic customer sync between PUG CRM and QuickBooks",
          "Automatically generate invoices from deals or orders",
          "Trigger follow-up actions based on invoice status (paid/unpaid)",
        ],

        usage: [
          "Create or update customers in PUG CRM",
          "Generate invoices directly from CRM",
          "Track invoice status and payment details",
          "Manage financial records efficiently",
        ],

        logs: [
          "Navigate to the 'Sync Logs' or 'Activity Logs' section",
          "View synced customers and invoices",
          "Check errors or failed sync attempts",
          "Monitor financial data sync performance",
        ],

        note: [
          "Ensure your QuickBooks account is active and properly configured",
          "Data sync depends on correct authentication and company selection",
          "You can manage detailed accounting and reports from QuickBooks dashboard",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "zendesk",
    name: "Zendesk",
    path: "/settings/integration/zendesk",
    category: "Desking Software",
    description:
      "Deliver a superior customer experience with cross-channel support.",
    logo: Zendesk,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The HubSpot Integration allows you to seamlessly connect your marketing, sales, and customer service data with PUG CRM, enabling better lead management and customer tracking.
</p>

<p style="margin-bottom:12px !important;">
  HubSpot is a powerful CRM platform that helps businesses manage contacts, deals, marketing campaigns, and customer interactions. By integrating HubSpot with PUG CRM, you can centralize your customer data and automate workflows.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves data synchronization, enhances lead tracking, and ensures that your sales and marketing teams stay aligned.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync contacts, deals, and companies with PUG CRM</li>
  <li>Track marketing and sales activities</li>
  <li>Automate lead management workflows</li>
  <li>Improve conversion rates and customer engagement</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Zendesk with your application, enabling you to manage customer support tickets, automate workflows, track interactions, and streamline your customer service operations through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your HubSpot account",
          "Navigate to Marketplace → Installed Apps → HubSpot Integration",
          "Authorize access to your HubSpot account",
        ],

        setup: [
          "Complete OAuth authentication with your HubSpot account",
          "Enter your PUG CRM API key if required",
          "Configure contact, deal, and company sync settings",
          "Set up webhooks or triggers for real-time updates",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name, Email, Phone Number",
          "Map deal fields like Deal Name, Stage, Amount, and Close Date",
          "Map company fields such as Company Name, Industry, and Website",
          "Map additional fields like Owner, Source, and Lifecycle Stage",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "zapier",
    name: "Zapier",
    path: "/settings/integration/zapier",
    category: "App Integration",
    description: "Effortlessly automate workflows across 5,000+ apps.",
    logo: Zapier,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Zapier Integration allows you to connect PUG CRM with thousands of third-party applications and automate workflows without writing any code.
</p>

<p style="margin-bottom:12px !important;">
  Zapier is a powerful automation platform that enables you to create “Zaps” — automated workflows that connect different apps and trigger actions based on events. By integrating Zapier with PUG CRM, you can automate repetitive tasks and streamline business processes.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps reduce manual work, improves operational efficiency, and ensures seamless data flow between PUG CRM and other tools you use daily.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Connect PUG CRM with 5000+ apps</li>
  <li>Automate repetitive tasks and workflows</li>
  <li>Sync data across multiple platforms in real-time</li>
  <li>Improve productivity and reduce manual errors</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Zapier with your application, enabling you to automate workflows, connect multiple apps, trigger actions based on events, and streamline your business processes through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Zapier account",
          "Navigate to Marketplace → Installed Apps → Zapier Integration",
          "Authorize access to your Zapier account",
        ],

        setup: [
          "Generate or enter your PUG CRM API key",
          "Log in to your Zapier account and create a new Zap",
          "Select PUG CRM as the Trigger or Action app",
          "Choose trigger events like New Lead, Contact Created, or Deal Updated",
          "Connect your PUG CRM account using API key or webhook URL",
          "Test the connection and publish the Zap",
        ],

        mapping: [
          "Map fields such as Lead Name, Email, Phone Number",
          "Map deal-related fields like Deal Name, Stage, and Value",
          "Map activity fields such as Task, Notes, and Status",
          "Map additional fields based on the connected app requirements",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "integrately",
    name: "Integrately",
    path: "/settings/integration/integrately",
    category: "App Integration",
    description: "Boost productivity with seamless one-click integrations.",
    logo: integrately,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Integrately Integration allows you to connect PUG CRM with hundreds of applications and automate your business workflows in just a few clicks.
</p>

<p style="margin-bottom:12px !important;">
  Integrately is a no-code automation platform that provides ready-to-use automation flows between apps. With this integration, you can instantly sync data between PUG CRM and other tools like marketing platforms, payment gateways, and communication apps.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps save time, reduce manual effort, and ensures smooth data transfer across systems, improving overall business efficiency.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Connect PUG CRM with 1000+ apps easily</li>
  <li>Use ready-made automation workflows</li>
  <li>Automate lead capture, follow-ups, and updates</li>
  <li>Ensure real-time data sync across platforms</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Integrately with your application, enabling you to automate workflows, connect multiple applications, trigger actions based on events, and streamline your business processes through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Integrately account",
          "Navigate to Marketplace → Installed Apps → Integrately Integration",
          "Authorize access to your Integrately account",
        ],

        setup: [
          "Generate or enter your PUG CRM API key",
          "Log in to your Integrately account and choose an automation",
          "Select PUG CRM as the Trigger or Action app",
          "Configure trigger events like New Lead, Contact Created, or Deal Updated",
          "Connect your PUG CRM account using API key or webhook",
          "Test and activate the automation workflow",
        ],

        mapping: [
          "Map fields such as Lead Name, Email, Phone Number",
          "Map deal-related fields like Deal Name, Stage, and Value",
          "Map activity fields such as Tasks, Notes, and Status",
          "Map additional fields based on the selected automation",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "arka",
    name: "Arka",
    path: "/settings/integration/arka",
    category: "Inventory Management",
    description:
      "Streamline operations with smart costing and inventory management.",
    logo: Arka,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Arka Integration enables you to connect your business operations platform with PUG CRM, allowing seamless data synchronization and workflow automation.
</p>

<p style="margin-bottom:12px !important;">
  Arka is a business management and automation platform that helps streamline processes such as operations, customer management, and internal workflows. By integrating Arka with PUG CRM, you can centralize your data and improve coordination across teams.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures better visibility of business processes, reduces manual effort, and enhances productivity by automating repetitive tasks between systems.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync operational and customer data with PUG CRM</li>
  <li>Automate workflows between Arka and CRM</li>
  <li>Centralize business data for better decision-making</li>
  <li>Improve efficiency and reduce manual errors</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Arka with your application, enabling you to automate workflows, manage data synchronization, track activities, and streamline your business operations through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Arka account",
          "Navigate to Marketplace → Installed Apps → Arka Integration",
          "Authorize access to your Arka account",
        ],

        setup: [
          "Enter your Arka API credentials or API key",
          "Enter your PUG CRM API key if required",
          "Configure data sync preferences and workflow rules",
          "Set up webhooks or triggers for real-time updates",
          "Save and verify the integration configuration",
        ],

        mapping: [
          "Map fields such as Customer Name, Email, Phone Number",
          "Map operational fields like Status, Category, and Source",
          "Map transaction or workflow-related fields if applicable",
          "Map additional custom fields based on your business needs",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "iris",
    name: "IRIS",
    path: "/settings/integration/iris",
    category: "Inventory Management",
    description:
      "Manage multiple projects, buildings & units with Iris Inventory management.",
    logo: iris,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Iris Integration allows you to connect your business or data management platform with PUG CRM, enabling seamless synchronization of customer and operational data.
</p>

<p style="margin-bottom:12px !important;">
  Iris is a flexible platform used for managing workflows, data processing, and business operations across different domains. By integrating Iris with PUG CRM, you can centralize your information and streamline communication between systems.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves data visibility, reduces manual work, and ensures that your teams always have access to accurate and up-to-date information.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync customer and operational data with PUG CRM</li>
  <li>Automate workflows between Iris and CRM</li>
  <li>Centralize data for better tracking and reporting</li>
  <li>Improve efficiency and reduce manual errors</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of IRIS with your application, enabling you to manage data processes, automate workflows, track system activities, and streamline operations through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Iris account",
          "Navigate to Marketplace → Installed Apps → Iris Integration",
          "Authorize access to your Iris account",
        ],

        setup: [
          "Enter your Iris API credentials or API key",
          "Enter your PUG CRM API key if required",
          "Configure data sync preferences and workflow rules",
          "Set up webhooks or triggers for real-time updates",
          "Save and verify the integration configuration",
        ],

        mapping: [
          "Map fields such as Customer Name, Email, Phone Number",
          "Map workflow-related fields like Status, Type, and Category",
          "Map activity or process-related fields if applicable",
          "Map additional custom fields based on your business requirements",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "channel_partner_management",
    name: "Channel Partner Management",
    path: "/settings/integration/google_ads",
    category: "Channel Partner",
    description:
      "A channel partner management app built to help PugCRM users manage partners effortlessly.",
    logo: channelpartner,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Channel Partner Management Integration enables you to manage and track your partners, distributors, and resellers directly within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Channel Partner Management systems help businesses handle partner onboarding, performance tracking, deal registrations, and commission management. By integrating this with PUG CRM, you can centralize partner data and streamline collaboration.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves partner visibility, enhances communication, and helps businesses scale efficiently through their partner network.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Manage partners, distributors, and resellers in one place</li>
  <li>Track partner-driven leads and deals</li>
  <li>Automate partner onboarding and communication</li>
  <li>Monitor partner performance and commissions</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Channel Partner Management with your application, enabling you to manage partner onboarding, track leads and commissions, automate workflows, and streamline partner interactions through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Navigate to Marketplace → Installed Apps → Channel Partner Management",
          "Connect your partner management system or configure manually",
          "Authorize access and enable integration",
        ],

        setup: [
          "Configure partner onboarding settings",
          "Define partner roles and access permissions",
          "Set up deal registration and lead sharing rules",
          "Configure commission structures and tracking",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map partner fields such as Partner Name, Company, Email, Phone Number",
          "Map lead and deal fields like Lead Source, Deal Value, and Status",
          "Map performance metrics such as Conversions, Revenue, and Targets",
          "Map additional fields like Region, Tier, and Partner Type",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "authkey",
    name: "Authkey",
    path: "/settings/integration/authkey",
    category: "Powerful Multi-Channel CPaaS Platform",
    description:
      "Unified cloud communication APIs for messaging, voice, email, WhatsApp, and beyond.",
    logo: Authkey,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Auth Key Integration allows secure authentication between PUG CRM and external applications using API keys or authentication tokens.
</p>

<p style="margin-bottom:12px !important;">
  An Auth Key (API Key or Token) is a unique identifier used to verify and authorize requests between systems. By using Auth Key integration, you can securely connect third-party services with PUG CRM without exposing sensitive credentials.
</p>

<p style="margin-bottom:12px !important;">
  This integration ensures secure data exchange, protects APIs from unauthorized access, and enables seamless communication between platforms.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Secure API authentication using keys or tokens</li>
  <li>Enable safe communication between PUG CRM and external apps</li>
  <li>Control access permissions and authorization levels</li>
  <li>Protect sensitive data and prevent unauthorized usage</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Authkey with your application, enabling you to send SMS and OTP messages, automate communication workflows, manage templates, and track delivery reports through a centralized and efficient system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Navigate to Marketplace → Installed Apps → Auth Key Integration",
          "Generate or enter your authentication key",
          "Assign permissions and access levels",
          "Save and activate the integration",
        ],

        setup: [
          "Generate an API key or token from PUG CRM settings",
          "Copy and securely store the Auth Key",
          "Provide the Auth Key to the external application",
          "Configure request headers (e.g., Authorization: Bearer <API_KEY>)",
          "Test the authentication and verify access",
        ],

        mapping: [
          "Map authentication headers such as Authorization and API Key",
          "Map user or system identifiers if required",
          "Map permission scopes and access levels",
          "Map additional security parameters like IP restrictions or expiry",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "go2markets",
    name: "Go2markets",
    path: "/settings/integration/go2markets",
    category: "Efficient SMS solution",
    description: "Deliver contextual messages at every key touchpoint.",
    logo: Go2market,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Go2Markets Integration allows you to connect your go-to-market platform with PUG CRM to manage leads, campaigns, and partner-driven growth strategies effectively.
</p>

<p style="margin-bottom:12px !important;">
  Go2Markets platforms help businesses plan and execute marketing, sales, and distribution strategies across multiple channels. By integrating Go2Markets with PUG CRM, you can centralize campaign data, track performance, and align your sales and marketing teams.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves visibility into go-to-market activities, enhances lead tracking, and helps optimize campaigns for better conversion and revenue growth.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync campaign and lead data with PUG CRM</li>
  <li>Track go-to-market performance across channels</li>
  <li>Align marketing and sales strategies</li>
  <li>Improve lead conversion and revenue tracking</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Go2Markets with your application, enabling you to manage lead distribution, automate marketing workflows, track campaign performance, and streamline your sales and marketing operations through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Go2Markets account",
          "Navigate to Marketplace → Installed Apps → Go2Markets Integration",
          "Authorize access to your Go2Markets account",
        ],

        setup: [
          "Enter your Go2Markets API credentials or API key",
          "Enter your PUG CRM API key if required",
          "Configure campaign and lead sync settings",
          "Set up tracking parameters and automation workflows",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map lead fields such as Name, Email, Phone Number",
          "Map campaign fields like Campaign Name, Source, and Status",
          "Map performance metrics such as Conversions, Clicks, and Revenue",
          "Map additional fields like Channel, Region, and Owner",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "gupshup",
    name: "Gupshup",
    path: "/integration/google_ads",
    category: "Conversational messaging platform",
    description: "Enable fast, reliable messaging with a trusted SMS API.",
    logo: gupshup,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Gupshup Integration allows you to connect WhatsApp and other messaging channels with PUG CRM to manage customer conversations and engagement efficiently.
</p>

<p style="margin-bottom:12px !important;">
  Gupshup is a leading messaging platform that enables businesses to communicate with customers via WhatsApp, SMS, and other channels. By integrating Gupshup with PUG CRM, you can centralize all conversations, automate messaging workflows, and improve customer communication.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps enhance customer engagement, streamline communication, and ensure faster responses through automated and real-time messaging.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send and receive WhatsApp and SMS messages within PUG CRM</li>
  <li>Automate notifications, alerts, and follow-ups</li>
  <li>Track customer conversations and engagement</li>
  <li>Improve response time and customer experience</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Gupshup with your application, enabling you to automate messaging, manage customer conversations across channels, implement chatbot workflows, and streamline communication through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Gupshup account",
          "Navigate to Marketplace → Installed Apps → Gupshup Integration",
          "Authorize access to your Gupshup account",
        ],

        setup: [
          "Enter your Gupshup API key and App credentials",
          "Configure WhatsApp Business number and messaging settings",
          "Set up webhooks for incoming messages and delivery reports",
          "Define message templates and automation rules",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name, Phone Number, and Email",
          "Map message fields like Message Content, Status, and Timestamp",
          "Map conversation fields such as Channel, Agent, and Session",
          "Map additional fields like Campaign, Template, and Source",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "sakari",
    name: "Sakari",
    path: "/settings/integration/sakari",
    category: "Cloud-based messaging service",
    description: "Deliver timely, relevant bulk messages at scale.",
    logo: sakari,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Sarkari Integration enables you to connect government-related services, portals, or data systems with PUG CRM for streamlined processing and record management.
</p>

<p style="margin-bottom:12px !important;">
  Sarkari systems typically refer to government platforms used for applications, verifications, compliance, and public services. By integrating these systems with PUG CRM, you can manage citizen or customer data, track application statuses, and ensure compliance workflows efficiently.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps organizations dealing with government services to automate processes, reduce paperwork, and maintain accurate records within a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Manage government-related applications and records</li>
  <li>Track application status and updates in real-time</li>
  <li>Automate compliance and verification workflows</li>
  <li>Centralize citizen or customer data within PUG CRM</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Sakari with your application, enabling you to send and receive SMS messages, automate messaging workflows, manage contacts, and track communication activities through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Connect to the respective Sarkari or government portal",
          "Navigate to Marketplace → Installed Apps → Sarkari Integration",
          "Authorize access and enable the integration",
        ],

        setup: [
          "Enter API credentials or authentication details provided by the government system",
          "Enter your PUG CRM API key if required",
          "Configure application tracking and data sync settings",
          "Set up verification workflows and compliance rules",
          "Save and verify the integration configuration",
        ],

        mapping: [
          "Map applicant fields such as Name, Email, Phone Number, and ID details",
          "Map application fields like Application ID, Type, Status, and Submission Date",
          "Map verification fields such as Approval Status, Documents, and Authority",
          "Map additional fields based on the specific government service",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "msg_advert",
    name: "Msg Advert",
    path: "/integration/google_ads",
    category: "Customized SMS services",
    description: "Create, send, and optimize messages for higher engagement.",
    logo: msgadvert,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The MSG Advert Integration allows you to manage and automate promotional messaging campaigns directly from PUG CRM across multiple communication channels.
</p>

<p style="margin-bottom:12px !important;">
  MSG Advert platforms are used to send bulk messages, advertisements, and promotional notifications via SMS, WhatsApp, Email, or other messaging channels. By integrating this with PUG CRM, you can run targeted campaigns and track their performance in one place.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps businesses improve marketing reach, engage customers effectively, and automate communication workflows for better campaign results.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send bulk promotional messages from PUG CRM</li>
  <li>Run targeted marketing campaigns across channels</li>
  <li>Track delivery, engagement, and response rates</li>
  <li>Automate campaign scheduling and follow-ups</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Msg Advert with your application, enabling you to manage bulk messaging campaigns, automate communication workflows, send promotional messages, and track delivery performance through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your MSG Advert platform account",
          "Navigate to Marketplace → Installed Apps → MSG Advert Integration",
          "Authorize access to your messaging account",
        ],

        setup: [
          "Enter your messaging platform API key or credentials",
          "Configure sender ID, messaging channels (SMS, WhatsApp, Email)",
          "Upload or sync contact lists from PUG CRM",
          "Create and configure message templates",
          "Set up scheduling and automation rules",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name, Phone Number, and Email",
          "Map campaign fields like Campaign Name, Type, and Status",
          "Map message fields such as Content, Template, and Delivery Status",
          "Map engagement fields like Clicks, Responses, and Conversions",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "oneXtel",
    name: "OneXtel",
    path: "/settings/integration/oneXtel",
    category: "Integrated telecommunication platform",
    description:
      "Smart SMS solutions that are secure, affordable, and insight-driven.",
    logo: OneXtel,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The OneXtel Integration allows you to connect cloud telephony services with PUG CRM to manage calls, SMS, and customer communication efficiently.
</p>

<p style="margin-bottom:12px !important;">
  OneXtel is a cloud communication platform that provides services like virtual numbers, IVR, call tracking, and SMS solutions. By integrating OneXtel with PUG CRM, you can track all communication activities and link them with leads, contacts, and deals.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer interaction, enables call tracking, and ensures better communication management directly within your CRM.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Track inbound and outbound calls within PUG CRM</li>
  <li>Send and receive SMS through OneXtel</li>
  <li>Link calls and messages to leads and contacts</li>
  <li>Improve communication tracking and customer engagement</li>
</ul>
`,
      howItWorks: {
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your OneXtel account",
          "Navigate to Marketplace → Installed Apps → OneXtel Integration",
          "Authorize access to your OneXtel account",
        ],

        setup: [
          "Enter your OneXtel API key and account credentials",
          "Configure virtual numbers and call routing settings",
          "Set up webhooks for call events and SMS delivery reports",
          "Enable call logging and message tracking in PUG CRM",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name, Phone Number, and Email",
          "Map call fields like Call Duration, Status, Recording, and Time",
          "Map SMS fields such as Message Content, Delivery Status, and Timestamp",
          "Map additional fields like Agent, Source, and Campaign",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "keep_intouch",
    name: "Keep In Touch",
    path: "/settings/integration/keep_intouch",
    category: "Efficient SMS solution",
    description: "Deliver contextual messages at every key touchpoint.",
    logo: keepintouch,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Keep In Touch Integration helps you maintain consistent communication with your leads and customers through automated follow-ups and reminders within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Keep In Touch systems are designed to ensure that no lead or customer is missed by scheduling regular interactions such as calls, emails, or messages. By integrating this with PUG CRM, you can automate engagement and nurture relationships effectively.
</p>

<p style="margin-bottom:12px !important;">
  This integration improves customer retention, strengthens relationships, and increases conversion rates by ensuring timely and personalized communication.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Automate follow-ups and reminders for leads and customers</li>
  <li>Schedule calls, emails, and messages بسهولة</li>
  <li>Track communication history and engagement</li>
  <li>Improve customer retention and conversion rates</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of OneXtel with your application, enabling you to manage calls, implement IVR workflows, automate communication processes, track call activities, and streamline customer interactions through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Navigate to Marketplace → Installed Apps → Keep In Touch Integration",
          "Configure communication preferences and channels",
          "Enable and activate the integration",
        ],

        setup: [
          "Define follow-up schedules and reminder intervals",
          "Choose communication channels such as Email, SMS, or Calls",
          "Create templates for messages and reminders",
          "Set automation rules based on lead or customer activity",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name, Email, and Phone Number",
          "Map follow-up fields like Next Contact Date, Reminder Type, and Status",
          "Map communication fields such as Message Type, Content, and Response",
          "Map additional fields like Owner, Priority, and Engagement Level",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "tublight_sms",
    name: "Tubelight SMS",
    path: "/settings/integration/tublight_sms",
    category: "Efficient SMS solution",
    description: "Deliver contextual messages at every key touchpoint.",
    logo: Tubelight_Logo,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Tubelight SMS Integration enables you to send and receive SMS messages directly from PUG CRM for effective customer communication and marketing.
</p>

<p style="margin-bottom:12px !important;">
  Tubelight SMS is a messaging platform that provides bulk SMS, transactional messaging, and OTP services. By integrating Tubelight SMS with PUG CRM, you can automate messaging workflows and keep all communication centralized.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer engagement, ensures timely notifications, and allows businesses to run targeted SMS campaigns efficiently.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send bulk and transactional SMS from PUG CRM</li>
  <li>Automate OTPs, alerts, and notifications</li>
  <li>Track SMS delivery and response status</li>
  <li>Improve customer communication and engagement</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Tubelight SMS with your application, enabling you to send bulk SMS, automate messaging workflows, manage templates, track delivery reports, and streamline communication processes through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Tubelight SMS account",
          "Navigate to Marketplace → Installed Apps → Tubelight SMS Integration",
          "Authorize access to your Tubelight SMS account",
        ],

        setup: [
          "Enter your Tubelight SMS API key and credentials",
          "Configure sender ID and SMS routing settings",
          "Set up webhooks for delivery reports and incoming messages",
          "Create SMS templates for campaigns and notifications",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name and Phone Number",
          "Map message fields like Message Content, Template ID, and Status",
          "Map delivery fields such as Delivery Status and Timestamp",
          "Map additional fields like Campaign, Source, and Response",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "sms_insta",
    name: "SMS Insta",
    path: "/settings/integration/sms_insta",
    category: "Efficient SMS solution",
    description: "Deliver contextual messages at every key touchpoint.",
    logo: smsInsta,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The SMS Insta Integration allows you to send instant SMS communications from PUG CRM for marketing, alerts, and customer engagement.
</p>

<p style="margin-bottom:12px !important;">
  SMS Insta is a messaging platform designed for fast and reliable delivery of bulk and transactional SMS. By integrating SMS Insta with PUG CRM, you can automate messaging workflows and ensure real-time communication with your leads and customers.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps businesses improve outreach, send timely notifications, and manage communication campaigns efficiently within a centralized CRM system.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Send instant bulk and transactional SMS from PUG CRM</li>
  <li>Automate alerts, reminders, and OTP messages</li>
  <li>Track SMS delivery and engagement</li>
  <li>Improve customer communication and response rates</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of SMS Insta with your application, enabling you to send bulk and transactional SMS, automate messaging workflows, manage templates, track delivery reports, and streamline communication processes through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your SMS Insta account",
          "Navigate to Marketplace → Installed Apps → SMS Insta Integration",
          "Authorize access to your SMS Insta account",
        ],

        setup: [
          "Enter your SMS Insta API key and account credentials",
          "Configure sender ID and messaging preferences",
          "Set up webhooks for delivery reports and incoming SMS",
          "Create and manage SMS templates",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map contact fields such as Name and Phone Number",
          "Map message fields like Content, Template ID, and Status",
          "Map delivery fields such as Delivery Status and Timestamp",
          "Map additional fields like Campaign, Source, and Response",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "shopify",
    name: "Shopify",
    path: "/settings/integration/shopify",
    category: "Ecommerce",
    description: "One platform to start, run, and scale your business.",
    logo: Shopify,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Shopify Integration allows you to connect your eCommerce store with PUG CRM to manage customers, orders, and sales data in one centralized platform.
</p>

<p style="margin-bottom:12px !important;">
  Shopify is a leading eCommerce platform that enables businesses to create and manage online stores, process orders, and handle payments. By integrating Shopify with PUG CRM, you can sync store data and gain better visibility into customer behavior and sales performance.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps improve customer tracking, streamline order management, and enables personalized marketing based on purchase history.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Sync customers, orders, and products with PUG CRM</li>
  <li>Track purchase history and customer behavior</li>
  <li>Automate order updates and notifications</li>
  <li>Improve sales and marketing strategies</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Shopify with your application, enabling you to manage products, orders, and customers, sync store data, automate workflows, and streamline your eCommerce operations through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in using your Shopify store account",
          "Navigate to Marketplace → Installed Apps → Shopify Integration",
          "Authorize access to your Shopify store",
        ],

        setup: [
          "Enter your Shopify store URL and API credentials",
          "Generate and provide Shopify Admin API access token",
          "Configure order, customer, and product sync settings",
          "Set up webhooks for real-time order and customer updates",
          "Save and verify the configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Email, Phone Number, and Address",
          "Map order fields like Order ID, Total Amount, Status, and Payment Method",
          "Map product fields such as Product Name, SKU, Price, and Quantity",
          "Map additional fields like Discount, Shipping Details, and Order Notes",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "setu_kyc",
    name: "SETU KYC",
    path: "/settings/integration/setu_kyc",
    category: "Verify individuals and businesses with ease",
    description:
      "Seamlessly verify users for loans, payouts, investments, and beyond.",
    logo: setu,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Setu KYC Integration enables you to perform seamless customer verification and identity checks directly within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Setu KYC is a digital verification platform that provides services like Aadhaar verification, PAN validation, bank account verification, and other compliance checks. By integrating Setu KYC with PUG CRM, you can automate KYC processes and ensure regulatory compliance.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps reduce manual verification efforts, speeds up onboarding, and ensures secure and accurate customer identity validation.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Perform Aadhaar, PAN, and bank account verification</li>
  <li>Automate customer onboarding and KYC processes</li>
  <li>Ensure compliance with regulatory requirements</li>
  <li>Reduce fraud and improve data accuracy</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Setu KYC with your application, enabling you to perform secure identity verification, automate KYC workflows, validate user information, and streamline onboarding processes through a centralized and compliant system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in or connect using your Setu KYC account",
          "Navigate to Marketplace → Installed Apps → Setu KYC Integration",
          "Authorize access to your Setu KYC services",
        ],

        setup: [
          "Enter your Setu API credentials (Client ID and Secret)",
          "Configure KYC verification types (Aadhaar, PAN, Bank, etc.)",
          "Set up webhook URLs for verification status updates",
          "Define workflows for customer onboarding and approval",
          "Save and verify the integration configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Date of Birth, and Phone Number",
          "Map identity fields like Aadhaar Number, PAN Number, and Bank Details",
          "Map verification fields such as Status, Response Code, and Timestamp",
          "Map additional fields like Document Type, Verification Type, and Remarks",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
  {
    id: "digio",
    name: "Digio",
    path: "/settings/integration/digio",
    category: "Digital KYC and Documentation Solutions",
    description:
      "Digitally sign documents, automate recurring payments, and verify identities with ease.",
    logo: digio,
    details: {
      overview: `
<p style="margin-bottom:12px !important;">
  The Digio Integration allows you to enable digital KYC, document verification, and e-signature workflows directly within PUG CRM.
</p>

<p style="margin-bottom:12px !important;">
  Digio is a digital documentation and identity verification platform that provides services like Aadhaar-based eSign, KYC verification, and digital document processing. By integrating Digio with PUG CRM, you can streamline onboarding and eliminate manual paperwork.
</p>

<p style="margin-bottom:12px !important;">
  This integration helps businesses accelerate customer onboarding, ensure compliance, and securely manage documents and signatures in a digital-first environment.
</p>

<ul style="margin-bottom:12px; padding-left:18px;">
  <li>Enable Aadhaar-based eSign and digital agreements</li>
  <li>Perform KYC and document verification</li>
  <li>Automate onboarding and approval workflows</li>
  <li>Securely manage and store digital documents</li>
</ul>
`,
      howItWorks: {
        description:"The steps below guide you through the complete integration of Digio with your application, enabling you to perform digital KYC, e-sign documents, verify identities, automate onboarding workflows, and streamline compliance processes through a centralized system.",
        steps: [
          "Click on the Install App button from the Marketplace",
          "Grant required permissions and click on 'Allow and Install'",
          "Sign in or connect using your Digio account",
          "Navigate to Marketplace → Installed Apps → Digio Integration",
          "Authorize access to your Digio account",
        ],

        setup: [
          "Enter your Digio API credentials (Client ID and Secret)",
          "Configure eSign and KYC workflow settings",
          "Set up webhook URLs for document and verification status updates",
          "Define document templates and signing workflows",
          "Save and verify the integration configuration",
        ],

        mapping: [
          "Map customer fields such as Name, Email, Phone Number",
          "Map document fields like Document Name, Type, and Status",
          "Map eSign fields such as Signer Name, Signing Status, and Timestamp",
          "Map KYC fields like Verification Status, ID Details, and Response",
        ],
      },
      permissions: [
        { name: "searchList", access: "read" },
        { name: "note", access: "read, write" },
        { name: "lead", access: "read, write, note" },
        { name: "pipeline", access: "read, readAll" },
        { name: "user", access: "read" },
      ],
    },
  },
];
